if (typeof window !== 'undefined') {
  !(function (e) {
    'use strict';
    function t(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function n(e) {
      for (var n = 1; n < arguments.length; n++) {
        var r = null != arguments[n] ? arguments[n] : {};
        n % 2
          ? t(Object(r), !0).forEach(function (t) {
              l(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : t(Object(r)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
      }
      return e;
    }
    function r(e) {
      return (
        (r =
          'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
            ? function (e) {
                return typeof e;
              }
            : function (e) {
                return e &&
                  'function' == typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? 'symbol'
                  : typeof e;
              }),
        r(e)
      );
    }
    function o(e, t, n, r, o, i, a) {
      try {
        var c = e[i](a),
          s = c.value;
      } catch (l) {
        return void n(l);
      }
      c.done ? t(s) : Promise.resolve(s).then(r, o);
    }
    function i(e) {
      return function () {
        var t = this,
          n = arguments;
        return new Promise(function (r, i) {
          var a = e.apply(t, n);
          function c(e) {
            o(a, r, i, c, s, 'next', e);
          }
          function s(e) {
            o(a, r, i, c, s, 'throw', e);
          }
          c(void 0);
        });
      };
    }
    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
    }
    function c(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          'value' in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function s(e, t, n) {
      return t && c(e.prototype, t), n && c(e, n), e;
    }
    function l(e, t, n) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = n),
        e
      );
    }
    function u(e, t) {
      if (e !== t) throw new TypeError('Cannot instantiate an arrow function');
    }
    var f =
        'undefined' != typeof globalThis
          ? globalThis
          : 'undefined' != typeof window
          ? window
          : 'undefined' != typeof global
          ? global
          : 'undefined' != typeof self
          ? self
          : {},
      h = function (e) {
        return e && e.Math == Math && e;
      },
      p =
        h('object' == typeof globalThis && globalThis) ||
        h('object' == typeof window && window) ||
        h('object' == typeof self && self) ||
        h('object' == typeof f && f) ||
        (function () {
          return this;
        })() ||
        Function('return this')(),
      d = { exports: {} },
      v = p,
      y = function (e, t) {
        try {
          Object.defineProperty(v, e, { value: t, configurable: !0, writable: !0 });
        } catch (n) {
          v[e] = t;
        }
        return t;
      },
      m = y,
      g = '__core-js_shared__',
      w = p[g] || m(g, {}),
      b = w;
    (d.exports = function (e, t) {
      return b[e] || (b[e] = void 0 !== t ? t : {});
    })('versions', []).push({
      version: '3.17.3',
      mode: 'global',
      copyright: 'В© 2021 Denis Pushkarev (zloirock.ru)',
    });
    var P,
      C,
      S = function (e) {
        if (null == e) throw TypeError("Can't call method on " + e);
        return e;
      },
      x = S,
      E = function (e) {
        return Object(x(e));
      },
      k = E,
      O = {}.hasOwnProperty,
      I =
        Object.hasOwn ||
        function (e, t) {
          return O.call(k(e), t);
        },
      A = 0,
      R = Math.random(),
      j = function (e) {
        return 'Symbol(' + String(void 0 === e ? '' : e) + ')_' + (++A + R).toString(36);
      },
      L = p,
      _ = function (e) {
        return 'function' == typeof e ? e : void 0;
      },
      U = function (e, t) {
        return arguments.length < 2 ? _(L[e]) : L[e] && L[e][t];
      },
      T = U('navigator', 'userAgent') || '',
      M = p,
      F = T,
      N = M.process,
      V = M.Deno,
      D = (N && N.versions) || (V && V.version),
      H = D && D.v8;
    H
      ? (C = (P = H.split('.'))[0] < 4 ? 1 : P[0] + P[1])
      : F &&
        (!(P = F.match(/Edge\/(\d+)/)) || P[1] >= 74) &&
        (P = F.match(/Chrome\/(\d+)/)) &&
        (C = P[1]);
    var B = C && +C,
      $ = function (e) {
        try {
          return !!e();
        } catch (t) {
          return !0;
        }
      },
      q = B,
      G = $,
      W =
        !!Object.getOwnPropertySymbols &&
        !G(function () {
          var e = Symbol();
          return !String(e) || !(Object(e) instanceof Symbol) || (!Symbol.sham && q && q < 41);
        }),
      Z = W && !Symbol.sham && 'symbol' == typeof Symbol.iterator,
      z = p,
      K = d.exports,
      Y = I,
      X = j,
      J = W,
      Q = Z,
      ee = K('wks'),
      te = z.Symbol,
      ne = Q ? te : (te && te.withoutSetter) || X,
      re = function (e) {
        return (
          (Y(ee, e) && (J || 'string' == typeof ee[e])) ||
            (J && Y(te, e) ? (ee[e] = te[e]) : (ee[e] = ne('Symbol.' + e))),
          ee[e]
        );
      },
      oe = {};
    oe[re('toStringTag')] = 'z';
    var ie = '[object z]' === String(oe),
      ae = { exports: {} },
      ce = !$(function () {
        return (
          7 !=
          Object.defineProperty({}, 1, {
            get: function () {
              return 7;
            },
          })[1]
        );
      }),
      se = {},
      le = function (e) {
        return 'object' == typeof e ? null !== e : 'function' == typeof e;
      },
      ue = le,
      fe = p.document,
      he = ue(fe) && ue(fe.createElement),
      pe = function (e) {
        return he ? fe.createElement(e) : {};
      },
      de = pe,
      ve =
        !ce &&
        !$(function () {
          return (
            7 !=
            Object.defineProperty(de('div'), 'a', {
              get: function () {
                return 7;
              },
            }).a
          );
        }),
      ye = le,
      me = function (e) {
        if (!ye(e)) throw TypeError(String(e) + ' is not an object');
        return e;
      },
      ge = U,
      we = Z
        ? function (e) {
            return 'symbol' == typeof e;
          }
        : function (e) {
            var t = ge('Symbol');
            return 'function' == typeof t && Object(e) instanceof t;
          },
      be = le,
      Pe = le,
      Ce = we,
      Se = function (e, t) {
        var n, r;
        if ('string' === t && 'function' == typeof (n = e.toString) && !be((r = n.call(e))))
          return r;
        if ('function' == typeof (n = e.valueOf) && !be((r = n.call(e)))) return r;
        if ('string' !== t && 'function' == typeof (n = e.toString) && !be((r = n.call(e))))
          return r;
        throw TypeError("Can't convert object to primitive value");
      },
      xe = re('toPrimitive'),
      Ee = function (e, t) {
        if (!Pe(e) || Ce(e)) return e;
        var n,
          r = e[xe];
        if (void 0 !== r) {
          if ((void 0 === t && (t = 'default'), (n = r.call(e, t)), !Pe(n) || Ce(n))) return n;
          throw TypeError("Can't convert object to primitive value");
        }
        return void 0 === t && (t = 'number'), Se(e, t);
      },
      ke = we,
      Oe = function (e) {
        var t = Ee(e, 'string');
        return ke(t) ? t : String(t);
      },
      Ie = ce,
      Ae = ve,
      Re = me,
      je = Oe,
      Le = Object.defineProperty;
    se.f = Ie
      ? Le
      : function (e, t, n) {
          if ((Re(e), (t = je(t)), Re(n), Ae))
            try {
              return Le(e, t, n);
            } catch (r) {}
          if ('get' in n || 'set' in n) throw TypeError('Accessors not supported');
          return 'value' in n && (e[t] = n.value), e;
        };
    var _e = function (e, t) {
        return { enumerable: !(1 & e), configurable: !(2 & e), writable: !(4 & e), value: t };
      },
      Ue = se,
      Te = _e,
      Me = ce
        ? function (e, t, n) {
            return Ue.f(e, t, Te(1, n));
          }
        : function (e, t, n) {
            return (e[t] = n), e;
          },
      Fe = w,
      Ne = Function.toString;
    'function' != typeof Fe.inspectSource &&
      (Fe.inspectSource = function (e) {
        return Ne.call(e);
      });
    var Ve,
      De,
      He,
      Be = Fe.inspectSource,
      $e = Be,
      qe = p.WeakMap,
      Ge = 'function' == typeof qe && /native code/.test($e(qe)),
      We = d.exports,
      Ze = j,
      ze = We('keys'),
      Ke = function (e) {
        return ze[e] || (ze[e] = Ze(e));
      },
      Ye = {},
      Xe = Ge,
      Je = le,
      Qe = Me,
      et = I,
      tt = w,
      nt = Ke,
      rt = Ye,
      ot = 'Object already initialized',
      it = p.WeakMap;
    if (Xe || tt.state) {
      var at = tt.state || (tt.state = new it()),
        ct = at.get,
        st = at.has,
        lt = at.set;
      (Ve = function (e, t) {
        if (st.call(at, e)) throw new TypeError(ot);
        return (t.facade = e), lt.call(at, e, t), t;
      }),
        (De = function (e) {
          return ct.call(at, e) || {};
        }),
        (He = function (e) {
          return st.call(at, e);
        });
    } else {
      var ut = nt('state');
      (rt[ut] = !0),
        (Ve = function (e, t) {
          if (et(e, ut)) throw new TypeError(ot);
          return (t.facade = e), Qe(e, ut, t), t;
        }),
        (De = function (e) {
          return et(e, ut) ? e[ut] : {};
        }),
        (He = function (e) {
          return et(e, ut);
        });
    }
    var ft = {
        set: Ve,
        get: De,
        has: He,
        enforce: function (e) {
          return He(e) ? De(e) : Ve(e, {});
        },
        getterFor: function (e) {
          return function (t) {
            var n;
            if (!Je(t) || (n = De(t)).type !== e)
              throw TypeError('Incompatible receiver, ' + e + ' required');
            return n;
          };
        },
      },
      ht = p,
      pt = Me,
      dt = I,
      vt = y,
      yt = Be,
      mt = ft.get,
      gt = ft.enforce,
      wt = String(String).split('String');
    (ae.exports = function (e, t, n, r) {
      var o,
        i = !!r && !!r.unsafe,
        a = !!r && !!r.enumerable,
        c = !!r && !!r.noTargetGet;
      'function' == typeof n &&
        ('string' != typeof t || dt(n, 'name') || pt(n, 'name', t),
        (o = gt(n)).source || (o.source = wt.join('string' == typeof t ? t : ''))),
        e !== ht
          ? (i ? !c && e[t] && (a = !0) : delete e[t], a ? (e[t] = n) : pt(e, t, n))
          : a
          ? (e[t] = n)
          : vt(t, n);
    })(Function.prototype, 'toString', function () {
      return ('function' == typeof this && mt(this).source) || yt(this);
    });
    var bt = {}.toString,
      Pt = function (e) {
        return bt.call(e).slice(8, -1);
      },
      Ct = ie,
      St = Pt,
      xt = re('toStringTag'),
      Et =
        'Arguments' ==
        St(
          (function () {
            return arguments;
          })()
        ),
      kt = Ct
        ? St
        : function (e) {
            var t, n, r;
            return void 0 === e
              ? 'Undefined'
              : null === e
              ? 'Null'
              : 'string' ==
                typeof (n = (function (e, t) {
                  try {
                    return e[t];
                  } catch (n) {}
                })((t = Object(e)), xt))
              ? n
              : Et
              ? St(t)
              : 'Object' == (r = St(t)) && 'function' == typeof t.callee
              ? 'Arguments'
              : r;
          },
      Ot = kt,
      It = ie
        ? {}.toString
        : function () {
            return '[object ' + Ot(this) + ']';
          },
      At = ie,
      Rt = ae.exports,
      jt = It;
    At || Rt(Object.prototype, 'toString', jt, { unsafe: !0 });
    var Lt = {},
      _t = {},
      Ut = {}.propertyIsEnumerable,
      Tt = Object.getOwnPropertyDescriptor,
      Mt = Tt && !Ut.call({ 1: 2 }, 1);
    _t.f = Mt
      ? function (e) {
          var t = Tt(this, e);
          return !!t && t.enumerable;
        }
      : Ut;
    var Ft = Pt,
      Nt = ''.split,
      Vt = $(function () {
        return !Object('z').propertyIsEnumerable(0);
      })
        ? function (e) {
            return 'String' == Ft(e) ? Nt.call(e, '') : Object(e);
          }
        : Object,
      Dt = Vt,
      Ht = S,
      Bt = function (e) {
        return Dt(Ht(e));
      },
      $t = ce,
      qt = _t,
      Gt = _e,
      Wt = Bt,
      Zt = Oe,
      zt = I,
      Kt = ve,
      Yt = Object.getOwnPropertyDescriptor;
    Lt.f = $t
      ? Yt
      : function (e, t) {
          if (((e = Wt(e)), (t = Zt(t)), Kt))
            try {
              return Yt(e, t);
            } catch (n) {}
          if (zt(e, t)) return Gt(!qt.f.call(e, t), e[t]);
        };
    var Xt = {},
      Jt = Math.ceil,
      Qt = Math.floor,
      en = function (e) {
        return isNaN((e = +e)) ? 0 : (e > 0 ? Qt : Jt)(e);
      },
      tn = en,
      nn = Math.min,
      rn = function (e) {
        return e > 0 ? nn(tn(e), 9007199254740991) : 0;
      },
      on = en,
      an = Math.max,
      cn = Math.min,
      sn = function (e, t) {
        var n = on(e);
        return n < 0 ? an(n + t, 0) : cn(n, t);
      },
      ln = Bt,
      un = rn,
      fn = sn,
      hn = function (e) {
        return function (t, n, r) {
          var o,
            i = ln(t),
            a = un(i.length),
            c = fn(r, a);
          if (e && n != n) {
            for (; a > c; ) if ((o = i[c++]) != o) return !0;
          } else for (; a > c; c++) if ((e || c in i) && i[c] === n) return e || c || 0;
          return !e && -1;
        };
      },
      pn = { includes: hn(!0), indexOf: hn(!1) },
      dn = I,
      vn = Bt,
      yn = pn.indexOf,
      mn = Ye,
      gn = function (e, t) {
        var n,
          r = vn(e),
          o = 0,
          i = [];
        for (n in r) !dn(mn, n) && dn(r, n) && i.push(n);
        for (; t.length > o; ) dn(r, (n = t[o++])) && (~yn(i, n) || i.push(n));
        return i;
      },
      wn = [
        'constructor',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'toLocaleString',
        'toString',
        'valueOf',
      ],
      bn = gn,
      Pn = wn.concat('length', 'prototype');
    Xt.f =
      Object.getOwnPropertyNames ||
      function (e) {
        return bn(e, Pn);
      };
    var Cn = {};
    Cn.f = Object.getOwnPropertySymbols;
    var Sn = Xt,
      xn = Cn,
      En = me,
      kn =
        U('Reflect', 'ownKeys') ||
        function (e) {
          var t = Sn.f(En(e)),
            n = xn.f;
          return n ? t.concat(n(e)) : t;
        },
      On = I,
      In = kn,
      An = Lt,
      Rn = se,
      jn = function (e, t) {
        for (var n = In(t), r = Rn.f, o = An.f, i = 0; i < n.length; i++) {
          var a = n[i];
          On(e, a) || r(e, a, o(t, a));
        }
      },
      Ln = $,
      _n = /#|\.prototype\./,
      Un = function (e, t) {
        var n = Mn[Tn(e)];
        return n == Nn || (n != Fn && ('function' == typeof t ? Ln(t) : !!t));
      },
      Tn = (Un.normalize = function (e) {
        return String(e).replace(_n, '.').toLowerCase();
      }),
      Mn = (Un.data = {}),
      Fn = (Un.NATIVE = 'N'),
      Nn = (Un.POLYFILL = 'P'),
      Vn = Un,
      Dn = p,
      Hn = Lt.f,
      Bn = Me,
      $n = ae.exports,
      qn = y,
      Gn = jn,
      Wn = Vn,
      Zn = function (e, t) {
        var n,
          r,
          o,
          i,
          a,
          c = e.target,
          s = e.global,
          l = e.stat;
        if ((n = s ? Dn : l ? Dn[c] || qn(c, {}) : (Dn[c] || {}).prototype))
          for (r in t) {
            if (
              ((i = t[r]),
              (o = e.noTargetGet ? (a = Hn(n, r)) && a.value : n[r]),
              !Wn(s ? r : c + (l ? '.' : '#') + r, e.forced) && void 0 !== o)
            ) {
              if (typeof i == typeof o) continue;
              Gn(i, o);
            }
            (e.sham || (o && o.sham)) && Bn(i, 'sham', !0), $n(n, r, i, e);
          }
      },
      zn = p.Promise,
      Kn = ae.exports,
      Yn = function (e, t, n) {
        for (var r in t) Kn(e, r, t[r], n);
        return e;
      },
      Xn = le,
      Jn = me,
      Qn = function (e) {
        if (!Xn(e) && null !== e) throw TypeError("Can't set " + String(e) + ' as a prototype');
        return e;
      },
      er =
        Object.setPrototypeOf ||
        ('__proto__' in {}
          ? (function () {
              var e,
                t = !1,
                n = {};
              try {
                (e = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set).call(
                  n,
                  []
                ),
                  (t = n instanceof Array);
              } catch (r) {}
              return function (n, r) {
                return Jn(n), Qn(r), t ? e.call(n, r) : (n.__proto__ = r), n;
              };
            })()
          : void 0),
      tr = se.f,
      nr = I,
      rr = re('toStringTag'),
      or = function (e, t, n) {
        e && !nr((e = n ? e : e.prototype), rr) && tr(e, rr, { configurable: !0, value: t });
      },
      ir = U,
      ar = se,
      cr = ce,
      sr = re('species'),
      lr = function (e) {
        var t = ir(e),
          n = ar.f;
        cr &&
          t &&
          !t[sr] &&
          n(t, sr, {
            configurable: !0,
            get: function () {
              return this;
            },
          });
      },
      ur = function (e) {
        if ('function' != typeof e) throw TypeError(String(e) + ' is not a function');
        return e;
      },
      fr = function (e, t, n) {
        if (!(e instanceof t)) throw TypeError('Incorrect ' + (n ? n + ' ' : '') + 'invocation');
        return e;
      },
      hr = {},
      pr = hr,
      dr = re('iterator'),
      vr = Array.prototype,
      yr = function (e) {
        return void 0 !== e && (pr.Array === e || vr[dr] === e);
      },
      mr = ur,
      gr = function (e, t, n) {
        if ((mr(e), void 0 === t)) return e;
        switch (n) {
          case 0:
            return function () {
              return e.call(t);
            };
          case 1:
            return function (n) {
              return e.call(t, n);
            };
          case 2:
            return function (n, r) {
              return e.call(t, n, r);
            };
          case 3:
            return function (n, r, o) {
              return e.call(t, n, r, o);
            };
        }
        return function () {
          return e.apply(t, arguments);
        };
      },
      wr = kt,
      br = hr,
      Pr = re('iterator'),
      Cr = function (e) {
        if (null != e) return e[Pr] || e['@@iterator'] || br[wr(e)];
      },
      Sr = me,
      xr = Cr,
      Er = function (e, t) {
        var n = arguments.length < 2 ? xr(e) : t;
        if ('function' != typeof n) throw TypeError(String(e) + ' is not iterable');
        return Sr(n.call(e));
      },
      kr = me,
      Or = function (e, t, n) {
        var r, o;
        kr(e);
        try {
          if (void 0 === (r = e.return)) {
            if ('throw' === t) throw n;
            return n;
          }
          r = r.call(e);
        } catch (i) {
          (o = !0), (r = i);
        }
        if ('throw' === t) throw n;
        if (o) throw r;
        return kr(r), n;
      },
      Ir = me,
      Ar = yr,
      Rr = rn,
      jr = gr,
      Lr = Er,
      _r = Cr,
      Ur = Or,
      Tr = function (e, t) {
        (this.stopped = e), (this.result = t);
      },
      Mr = re('iterator'),
      Fr = !1;
    try {
      var Nr = 0,
        Vr = {
          next: function () {
            return { done: !!Nr++ };
          },
          return: function () {
            Fr = !0;
          },
        };
      (Vr[Mr] = function () {
        return this;
      }),
        Array.from(Vr, function () {
          throw 2;
        });
    } catch (lg) {}
    var Dr,
      Hr,
      Br,
      $r,
      qr = me,
      Gr = ur,
      Wr = re('species'),
      Zr = U('document', 'documentElement'),
      zr = /(?:ipad|iphone|ipod).*applewebkit/i.test(T),
      Kr = 'process' == Pt(p.process),
      Yr = p,
      Xr = $,
      Jr = gr,
      Qr = Zr,
      eo = pe,
      to = zr,
      no = Kr,
      ro = Yr.setImmediate,
      oo = Yr.clearImmediate,
      io = Yr.process,
      ao = Yr.MessageChannel,
      co = Yr.Dispatch,
      so = 0,
      lo = {},
      uo = 'onreadystatechange';
    try {
      Dr = Yr.location;
    } catch (lg) {}
    var fo = function (e) {
        if (lo.hasOwnProperty(e)) {
          var t = lo[e];
          delete lo[e], t();
        }
      },
      ho = function (e) {
        return function () {
          fo(e);
        };
      },
      po = function (e) {
        fo(e.data);
      },
      vo = function (e) {
        Yr.postMessage(String(e), Dr.protocol + '//' + Dr.host);
      };
    (ro && oo) ||
      ((ro = function (e) {
        for (var t = [], n = arguments.length, r = 1; n > r; ) t.push(arguments[r++]);
        return (
          (lo[++so] = function () {
            ('function' == typeof e ? e : Function(e)).apply(void 0, t);
          }),
          Hr(so),
          so
        );
      }),
      (oo = function (e) {
        delete lo[e];
      }),
      no
        ? (Hr = function (e) {
            io.nextTick(ho(e));
          })
        : co && co.now
        ? (Hr = function (e) {
            co.now(ho(e));
          })
        : ao && !to
        ? (($r = (Br = new ao()).port2),
          (Br.port1.onmessage = po),
          (Hr = Jr($r.postMessage, $r, 1)))
        : Yr.addEventListener &&
          'function' == typeof postMessage &&
          !Yr.importScripts &&
          Dr &&
          'file:' !== Dr.protocol &&
          !Xr(vo)
        ? ((Hr = vo), Yr.addEventListener('message', po, !1))
        : (Hr =
            uo in eo('script')
              ? function (e) {
                  Qr.appendChild(eo('script')).onreadystatechange = function () {
                    Qr.removeChild(this), fo(e);
                  };
                }
              : function (e) {
                  setTimeout(ho(e), 0);
                }));
    var yo,
      mo,
      go,
      wo,
      bo,
      Po,
      Co,
      So,
      xo = { set: ro, clear: oo },
      Eo = p,
      ko = /ipad|iphone|ipod/i.test(T) && void 0 !== Eo.Pebble,
      Oo = /web0s(?!.*chrome)/i.test(T),
      Io = p,
      Ao = Lt.f,
      Ro = xo.set,
      jo = zr,
      Lo = ko,
      _o = Oo,
      Uo = Kr,
      To = Io.MutationObserver || Io.WebKitMutationObserver,
      Mo = Io.document,
      Fo = Io.process,
      No = Io.Promise,
      Vo = Ao(Io, 'queueMicrotask'),
      Do = Vo && Vo.value;
    Do ||
      ((yo = function () {
        var e, t;
        for (Uo && (e = Fo.domain) && e.exit(); mo; ) {
          (t = mo.fn), (mo = mo.next);
          try {
            t();
          } catch (lg) {
            throw (mo ? wo() : (go = void 0), lg);
          }
        }
        (go = void 0), e && e.enter();
      }),
      jo || Uo || _o || !To || !Mo
        ? !Lo && No && No.resolve
          ? (((Co = No.resolve(void 0)).constructor = No),
            (So = Co.then),
            (wo = function () {
              So.call(Co, yo);
            }))
          : (wo = Uo
              ? function () {
                  Fo.nextTick(yo);
                }
              : function () {
                  Ro.call(Io, yo);
                })
        : ((bo = !0),
          (Po = Mo.createTextNode('')),
          new To(yo).observe(Po, { characterData: !0 }),
          (wo = function () {
            Po.data = bo = !bo;
          })));
    var Ho =
        Do ||
        function (e) {
          var t = { fn: e, next: void 0 };
          go && (go.next = t), mo || ((mo = t), wo()), (go = t);
        },
      Bo = {},
      $o = ur,
      qo = function (e) {
        var t, n;
        (this.promise = new e(function (e, r) {
          if (void 0 !== t || void 0 !== n) throw TypeError('Bad Promise constructor');
          (t = e), (n = r);
        })),
          (this.resolve = $o(t)),
          (this.reject = $o(n));
      };
    Bo.f = function (e) {
      return new qo(e);
    };
    var Go,
      Wo,
      Zo,
      zo,
      Ko = me,
      Yo = le,
      Xo = Bo,
      Jo = p,
      Qo = 'object' == typeof window,
      ei = Zn,
      ti = p,
      ni = U,
      ri = zn,
      oi = ae.exports,
      ii = Yn,
      ai = er,
      ci = or,
      si = lr,
      li = le,
      ui = ur,
      fi = fr,
      hi = Be,
      pi = function (e, t, n) {
        var r,
          o,
          i,
          a,
          c,
          s,
          l,
          u = n && n.that,
          f = !(!n || !n.AS_ENTRIES),
          h = !(!n || !n.IS_ITERATOR),
          p = !(!n || !n.INTERRUPTED),
          d = jr(t, u, 1 + f + p),
          v = function (e) {
            return r && Ur(r, 'normal', e), new Tr(!0, e);
          },
          y = function (e) {
            return f ? (Ir(e), p ? d(e[0], e[1], v) : d(e[0], e[1])) : p ? d(e, v) : d(e);
          };
        if (h) r = e;
        else {
          if ('function' != typeof (o = _r(e))) throw TypeError('Target is not iterable');
          if (Ar(o)) {
            for (i = 0, a = Rr(e.length); a > i; i++)
              if ((c = y(e[i])) && c instanceof Tr) return c;
            return new Tr(!1);
          }
          r = Lr(e, o);
        }
        for (s = r.next; !(l = s.call(r)).done; ) {
          try {
            c = y(l.value);
          } catch (lg) {
            Ur(r, 'throw', lg);
          }
          if ('object' == typeof c && c && c instanceof Tr) return c;
        }
        return new Tr(!1);
      },
      di = function (e, t) {
        if (!t && !Fr) return !1;
        var n = !1;
        try {
          var r = {};
          (r[Mr] = function () {
            return {
              next: function () {
                return { done: (n = !0) };
              },
            };
          }),
            e(r);
        } catch (lg) {}
        return n;
      },
      vi = function (e, t) {
        var n,
          r = qr(e).constructor;
        return void 0 === r || null == (n = qr(r)[Wr]) ? t : Gr(n);
      },
      yi = xo.set,
      mi = Ho,
      gi = function (e, t) {
        if ((Ko(e), Yo(t) && t.constructor === e)) return t;
        var n = Xo.f(e);
        return (0, n.resolve)(t), n.promise;
      },
      wi = function (e, t) {
        var n = Jo.console;
        n && n.error && (1 === arguments.length ? n.error(e) : n.error(e, t));
      },
      bi = Bo,
      Pi = function (e) {
        try {
          return { error: !1, value: e() };
        } catch (lg) {
          return { error: !0, value: lg };
        }
      },
      Ci = ft,
      Si = Vn,
      xi = Qo,
      Ei = Kr,
      ki = B,
      Oi = re('species'),
      Ii = 'Promise',
      Ai = Ci.get,
      Ri = Ci.set,
      ji = Ci.getterFor(Ii),
      Li = ri && ri.prototype,
      _i = ri,
      Ui = Li,
      Ti = ti.TypeError,
      Mi = ti.document,
      Fi = ti.process,
      Ni = bi.f,
      Vi = Ni,
      Di = !!(Mi && Mi.createEvent && ti.dispatchEvent),
      Hi = 'function' == typeof PromiseRejectionEvent,
      Bi = 'unhandledrejection',
      $i = !1,
      qi = Si(Ii, function () {
        var e = hi(_i),
          t = e !== String(_i);
        if (!t && 66 === ki) return !0;
        if (ki >= 51 && /native code/.test(e)) return !1;
        var n = new _i(function (e) {
            e(1);
          }),
          r = function (e) {
            e(
              function () {},
              function () {}
            );
          };
        return (
          ((n.constructor = {})[Oi] = r),
          !($i = n.then(function () {}) instanceof r) || (!t && xi && !Hi)
        );
      }),
      Gi =
        qi ||
        !di(function (e) {
          _i.all(e).catch(function () {});
        }),
      Wi = function (e) {
        var t;
        return !(!li(e) || 'function' != typeof (t = e.then)) && t;
      },
      Zi = function (e, t) {
        if (!e.notified) {
          e.notified = !0;
          var n = e.reactions;
          mi(function () {
            for (var r = e.value, o = 1 == e.state, i = 0; n.length > i; ) {
              var a,
                c,
                s,
                l = n[i++],
                u = o ? l.ok : l.fail,
                f = l.resolve,
                h = l.reject,
                p = l.domain;
              try {
                u
                  ? (o || (2 === e.rejection && Xi(e), (e.rejection = 1)),
                    !0 === u ? (a = r) : (p && p.enter(), (a = u(r)), p && (p.exit(), (s = !0))),
                    a === l.promise
                      ? h(Ti('Promise-chain cycle'))
                      : (c = Wi(a))
                      ? c.call(a, f, h)
                      : f(a))
                  : h(r);
              } catch (lg) {
                p && !s && p.exit(), h(lg);
              }
            }
            (e.reactions = []), (e.notified = !1), t && !e.rejection && Ki(e);
          });
        }
      },
      zi = function (e, t, n) {
        var r, o;
        Di
          ? (((r = Mi.createEvent('Event')).promise = t),
            (r.reason = n),
            r.initEvent(e, !1, !0),
            ti.dispatchEvent(r))
          : (r = { promise: t, reason: n }),
          !Hi && (o = ti['on' + e]) ? o(r) : e === Bi && wi('Unhandled promise rejection', n);
      },
      Ki = function (e) {
        yi.call(ti, function () {
          var t,
            n = e.facade,
            r = e.value;
          if (
            Yi(e) &&
            ((t = Pi(function () {
              Ei ? Fi.emit('unhandledRejection', r, n) : zi(Bi, n, r);
            })),
            (e.rejection = Ei || Yi(e) ? 2 : 1),
            t.error)
          )
            throw t.value;
        });
      },
      Yi = function (e) {
        return 1 !== e.rejection && !e.parent;
      },
      Xi = function (e) {
        yi.call(ti, function () {
          var t = e.facade;
          Ei ? Fi.emit('rejectionHandled', t) : zi('rejectionhandled', t, e.value);
        });
      },
      Ji = function (e, t, n) {
        return function (r) {
          e(t, r, n);
        };
      },
      Qi = function (e, t, n) {
        e.done || ((e.done = !0), n && (e = n), (e.value = t), (e.state = 2), Zi(e, !0));
      },
      ea = function (e, t, n) {
        if (!e.done) {
          (e.done = !0), n && (e = n);
          try {
            if (e.facade === t) throw Ti("Promise can't be resolved itself");
            var r = Wi(t);
            r
              ? mi(function () {
                  var n = { done: !1 };
                  try {
                    r.call(t, Ji(ea, n, e), Ji(Qi, n, e));
                  } catch (lg) {
                    Qi(n, lg, e);
                  }
                })
              : ((e.value = t), (e.state = 1), Zi(e, !1));
          } catch (lg) {
            Qi({ done: !1 }, lg, e);
          }
        }
      };
    if (
      qi &&
      ((Ui = (_i = function (e) {
        fi(this, _i, Ii), ui(e), Go.call(this);
        var t = Ai(this);
        try {
          e(Ji(ea, t), Ji(Qi, t));
        } catch (lg) {
          Qi(t, lg);
        }
      }).prototype),
      ((Go = function (e) {
        Ri(this, {
          type: Ii,
          done: !1,
          notified: !1,
          parent: !1,
          reactions: [],
          rejection: !1,
          state: 0,
          value: void 0,
        });
      }).prototype = ii(Ui, {
        then: function (e, t) {
          var n = ji(this),
            r = Ni(vi(this, _i));
          return (
            (r.ok = 'function' != typeof e || e),
            (r.fail = 'function' == typeof t && t),
            (r.domain = Ei ? Fi.domain : void 0),
            (n.parent = !0),
            n.reactions.push(r),
            0 != n.state && Zi(n, !1),
            r.promise
          );
        },
        catch: function (e) {
          return this.then(void 0, e);
        },
      })),
      (Wo = function () {
        var e = new Go(),
          t = Ai(e);
        (this.promise = e), (this.resolve = Ji(ea, t)), (this.reject = Ji(Qi, t));
      }),
      (bi.f = Ni =
        function (e) {
          return e === _i || e === Zo ? new Wo(e) : Vi(e);
        }),
      'function' == typeof ri && Li !== Object.prototype)
    ) {
      (zo = Li.then),
        $i ||
          (oi(
            Li,
            'then',
            function (e, t) {
              var n = this;
              return new _i(function (e, t) {
                zo.call(n, e, t);
              }).then(e, t);
            },
            { unsafe: !0 }
          ),
          oi(Li, 'catch', Ui.catch, { unsafe: !0 }));
      try {
        delete Li.constructor;
      } catch (lg) {}
      ai && ai(Li, Ui);
    }
    ei({ global: !0, wrap: !0, forced: qi }, { Promise: _i }),
      ci(_i, Ii, !1),
      si(Ii),
      (Zo = ni(Ii)),
      ei(
        { target: Ii, stat: !0, forced: qi },
        {
          reject: function (e) {
            var t = Ni(this);
            return t.reject.call(void 0, e), t.promise;
          },
        }
      ),
      ei(
        { target: Ii, stat: !0, forced: qi },
        {
          resolve: function (e) {
            return gi(this, e);
          },
        }
      ),
      ei(
        { target: Ii, stat: !0, forced: Gi },
        {
          all: function (e) {
            var t = this,
              n = Ni(t),
              r = n.resolve,
              o = n.reject,
              i = Pi(function () {
                var n = ui(t.resolve),
                  i = [],
                  a = 0,
                  c = 1;
                pi(e, function (e) {
                  var s = a++,
                    l = !1;
                  i.push(void 0),
                    c++,
                    n.call(t, e).then(function (e) {
                      l || ((l = !0), (i[s] = e), --c || r(i));
                    }, o);
                }),
                  --c || r(i);
              });
            return i.error && o(i.value), n.promise;
          },
          race: function (e) {
            var t = this,
              n = Ni(t),
              r = n.reject,
              o = Pi(function () {
                var o = ui(t.resolve);
                pi(e, function (e) {
                  o.call(t, e).then(n.resolve, r);
                });
              });
            return o.error && r(o.value), n.promise;
          },
        }
      );
    var ta = we,
      na = function (e) {
        if (ta(e)) throw TypeError('Cannot convert a Symbol value to a string');
        return String(e);
      },
      ra = me,
      oa = function () {
        var e = ra(this),
          t = '';
        return (
          e.global && (t += 'g'),
          e.ignoreCase && (t += 'i'),
          e.multiline && (t += 'm'),
          e.dotAll && (t += 's'),
          e.unicode && (t += 'u'),
          e.sticky && (t += 'y'),
          t
        );
      },
      ia = {},
      aa = $,
      ca = p.RegExp;
    (ia.UNSUPPORTED_Y = aa(function () {
      var e = ca('a', 'y');
      return (e.lastIndex = 2), null != e.exec('abcd');
    })),
      (ia.BROKEN_CARET = aa(function () {
        var e = ca('^r', 'gy');
        return (e.lastIndex = 2), null != e.exec('str');
      }));
    var sa,
      la = gn,
      ua = wn,
      fa =
        Object.keys ||
        function (e) {
          return la(e, ua);
        },
      ha = se,
      pa = me,
      da = fa,
      va = ce
        ? Object.defineProperties
        : function (e, t) {
            pa(e);
            for (var n, r = da(t), o = r.length, i = 0; o > i; ) ha.f(e, (n = r[i++]), t[n]);
            return e;
          },
      ya = me,
      ma = va,
      ga = wn,
      wa = Ye,
      ba = Zr,
      Pa = pe,
      Ca = Ke('IE_PROTO'),
      Sa = function () {},
      xa = function (e) {
        return '<script>' + e + '</' + 'script>';
      },
      Ea = function (e) {
        e.write(xa('')), e.close();
        var t = e.parentWindow.Object;
        return (e = null), t;
      },
      ka = function () {
        try {
          sa = new ActiveXObject('htmlfile');
        } catch (lg) {}
        var e, t;
        ka =
          'undefined' != typeof document
            ? document.domain && sa
              ? Ea(sa)
              : (((t = Pa('iframe')).style.display = 'none'),
                ba.appendChild(t),
                (t.src = String('javascript:')),
                (e = t.contentWindow.document).open(),
                e.write(xa('document.F=Object')),
                e.close(),
                e.F)
            : Ea(sa);
        for (var n = ga.length; n--; ) delete ka.prototype[ga[n]];
        return ka();
      };
    wa[Ca] = !0;
    var Oa =
        Object.create ||
        function (e, t) {
          var n;
          return (
            null !== e
              ? ((Sa.prototype = ya(e)), (n = new Sa()), (Sa.prototype = null), (n[Ca] = e))
              : (n = ka()),
            void 0 === t ? n : ma(n, t)
          );
        },
      Ia = $,
      Aa = p.RegExp,
      Ra = Ia(function () {
        var e = Aa('.', 's');
        return !(e.dotAll && e.exec('\n') && 's' === e.flags);
      }),
      ja = $,
      La = p.RegExp,
      _a = ja(function () {
        var e = La('(?<a>b)', 'g');
        return 'b' !== e.exec('b').groups.a || 'bc' !== 'b'.replace(e, '$<a>c');
      }),
      Ua = na,
      Ta = oa,
      Ma = ia,
      Fa = d.exports,
      Na = Oa,
      Va = ft.get,
      Da = Ra,
      Ha = _a,
      Ba = RegExp.prototype.exec,
      $a = Fa('native-string-replace', String.prototype.replace),
      qa = Ba,
      Ga = (function () {
        var e = /a/,
          t = /b*/g;
        return Ba.call(e, 'a'), Ba.call(t, 'a'), 0 !== e.lastIndex || 0 !== t.lastIndex;
      })(),
      Wa = Ma.UNSUPPORTED_Y || Ma.BROKEN_CARET,
      Za = void 0 !== /()??/.exec('')[1];
    (Ga || Za || Wa || Da || Ha) &&
      (qa = function (e) {
        var t,
          n,
          r,
          o,
          i,
          a,
          c,
          s = this,
          l = Va(s),
          u = Ua(e),
          f = l.raw;
        if (f)
          return (f.lastIndex = s.lastIndex), (t = qa.call(f, u)), (s.lastIndex = f.lastIndex), t;
        var h = l.groups,
          p = Wa && s.sticky,
          d = Ta.call(s),
          v = s.source,
          y = 0,
          m = u;
        if (
          (p &&
            (-1 === (d = d.replace('y', '')).indexOf('g') && (d += 'g'),
            (m = u.slice(s.lastIndex)),
            s.lastIndex > 0 &&
              (!s.multiline || (s.multiline && '\n' !== u.charAt(s.lastIndex - 1))) &&
              ((v = '(?: ' + v + ')'), (m = ' ' + m), y++),
            (n = new RegExp('^(?:' + v + ')', d))),
          Za && (n = new RegExp('^' + v + '$(?!\\s)', d)),
          Ga && (r = s.lastIndex),
          (o = Ba.call(p ? n : s, m)),
          p
            ? o
              ? ((o.input = o.input.slice(y)),
                (o[0] = o[0].slice(y)),
                (o.index = s.lastIndex),
                (s.lastIndex += o[0].length))
              : (s.lastIndex = 0)
            : Ga && o && (s.lastIndex = s.global ? o.index + o[0].length : r),
          Za &&
            o &&
            o.length > 1 &&
            $a.call(o[0], n, function () {
              for (i = 1; i < arguments.length - 2; i++) void 0 === arguments[i] && (o[i] = void 0);
            }),
          o && h)
        )
          for (o.groups = a = Na(null), i = 0; i < h.length; i++) a[(c = h[i])[0]] = o[c[1]];
        return o;
      });
    var za = qa;
    Zn({ target: 'RegExp', proto: !0, forced: /./.exec !== za }, { exec: za });
    var Ka = ae.exports,
      Ya = za,
      Xa = $,
      Ja = re,
      Qa = Me,
      ec = Ja('species'),
      tc = RegExp.prototype,
      nc = function (e, t, n, r) {
        var o = Ja(e),
          i = !Xa(function () {
            var t = {};
            return (
              (t[o] = function () {
                return 7;
              }),
              7 != ''[e](t)
            );
          }),
          a =
            i &&
            !Xa(function () {
              var t = !1,
                n = /a/;
              return (
                'split' === e &&
                  (((n = {}).constructor = {}),
                  (n.constructor[ec] = function () {
                    return n;
                  }),
                  (n.flags = ''),
                  (n[o] = /./[o])),
                (n.exec = function () {
                  return (t = !0), null;
                }),
                n[o](''),
                !t
              );
            });
        if (!i || !a || n) {
          var c = /./[o],
            s = t(o, ''[e], function (e, t, n, r, o) {
              var a = t.exec;
              return a === Ya || a === tc.exec
                ? i && !o
                  ? { done: !0, value: c.call(t, n, r) }
                  : { done: !0, value: e.call(n, t, r) }
                : { done: !1 };
            });
          Ka(String.prototype, e, s[0]), Ka(tc, o, s[1]);
        }
        r && Qa(tc[o], 'sham', !0);
      },
      rc = en,
      oc = na,
      ic = S,
      ac = function (e) {
        return function (t, n) {
          var r,
            o,
            i = oc(ic(t)),
            a = rc(n),
            c = i.length;
          return a < 0 || a >= c
            ? e
              ? ''
              : void 0
            : (r = i.charCodeAt(a)) < 55296 ||
              r > 56319 ||
              a + 1 === c ||
              (o = i.charCodeAt(a + 1)) < 56320 ||
              o > 57343
            ? e
              ? i.charAt(a)
              : r
            : e
            ? i.slice(a, a + 2)
            : o - 56320 + ((r - 55296) << 10) + 65536;
        };
      },
      cc = { codeAt: ac(!1), charAt: ac(!0) },
      sc = cc.charAt,
      lc = function (e, t, n) {
        return t + (n ? sc(e, t).length : 1);
      },
      uc = E,
      fc = Math.floor,
      hc = ''.replace,
      pc = /\$([$&'`]|\d{1,2}|<[^>]*>)/g,
      dc = /\$([$&'`]|\d{1,2})/g,
      vc = Pt,
      yc = za,
      mc = function (e, t) {
        var n = e.exec;
        if ('function' == typeof n) {
          var r = n.call(e, t);
          if ('object' != typeof r)
            throw TypeError('RegExp exec method returned something other than an Object or null');
          return r;
        }
        if ('RegExp' !== vc(e)) throw TypeError('RegExp#exec called on incompatible receiver');
        return yc.call(e, t);
      },
      gc = nc,
      wc = $,
      bc = me,
      Pc = en,
      Cc = rn,
      Sc = na,
      xc = S,
      Ec = lc,
      kc = function (e, t, n, r, o, i) {
        var a = n + e.length,
          c = r.length,
          s = dc;
        return (
          void 0 !== o && ((o = uc(o)), (s = pc)),
          hc.call(i, s, function (i, s) {
            var l;
            switch (s.charAt(0)) {
              case '$':
                return '$';
              case '&':
                return e;
              case '`':
                return t.slice(0, n);
              case "'":
                return t.slice(a);
              case '<':
                l = o[s.slice(1, -1)];
                break;
              default:
                var u = +s;
                if (0 === u) return i;
                if (u > c) {
                  var f = fc(u / 10);
                  return 0 === f
                    ? i
                    : f <= c
                    ? void 0 === r[f - 1]
                      ? s.charAt(1)
                      : r[f - 1] + s.charAt(1)
                    : i;
                }
                l = r[u - 1];
            }
            return void 0 === l ? '' : l;
          })
        );
      },
      Oc = mc,
      Ic = re('replace'),
      Ac = Math.max,
      Rc = Math.min,
      jc = '$0' === 'a'.replace(/./, '$0'),
      Lc = !!/./[Ic] && '' === /./[Ic]('a', '$0');
    gc(
      'replace',
      function (e, t, n) {
        var r = Lc ? '$' : '$0';
        return [
          function (e, n) {
            var r = xc(this),
              o = null == e ? void 0 : e[Ic];
            return void 0 !== o ? o.call(e, r, n) : t.call(Sc(r), e, n);
          },
          function (e, o) {
            var i = bc(this),
              a = Sc(e);
            if ('string' == typeof o && -1 === o.indexOf(r) && -1 === o.indexOf('$<')) {
              var c = n(t, i, a, o);
              if (c.done) return c.value;
            }
            var s = 'function' == typeof o;
            s || (o = Sc(o));
            var l = i.global;
            if (l) {
              var u = i.unicode;
              i.lastIndex = 0;
            }
            for (var f = []; ; ) {
              var h = Oc(i, a);
              if (null === h) break;
              if ((f.push(h), !l)) break;
              '' === Sc(h[0]) && (i.lastIndex = Ec(a, Cc(i.lastIndex), u));
            }
            for (var p, d = '', v = 0, y = 0; y < f.length; y++) {
              h = f[y];
              for (
                var m = Sc(h[0]), g = Ac(Rc(Pc(h.index), a.length), 0), w = [], b = 1;
                b < h.length;
                b++
              )
                w.push(void 0 === (p = h[b]) ? p : String(p));
              var P = h.groups;
              if (s) {
                var C = [m].concat(w, g, a);
                void 0 !== P && C.push(P);
                var S = Sc(o.apply(void 0, C));
              } else S = kc(m, a, g, w, P, o);
              g >= v && ((d += a.slice(v, g) + S), (v = g + m.length));
            }
            return d + a.slice(v);
          },
        ];
      },
      !!wc(function () {
        var e = /./;
        return (
          (e.exec = function () {
            var e = [];
            return (e.groups = { a: '7' }), e;
          }),
          '7' !== ''.replace(e, '$<a>')
        );
      }) ||
        !jc ||
        Lc
    );
    var _c = ae.exports,
      Uc = me,
      Tc = na,
      Mc = $,
      Fc = oa,
      Nc = 'toString',
      Vc = RegExp.prototype,
      Dc = Vc.toString,
      Hc = Mc(function () {
        return '/a/b' != Dc.call({ source: 'a', flags: 'b' });
      }),
      Bc = Dc.name != Nc;
    (Hc || Bc) &&
      _c(
        RegExp.prototype,
        Nc,
        function () {
          var e = Uc(this),
            t = Tc(e.source),
            n = e.flags;
          return (
            '/' +
            t +
            '/' +
            Tc(void 0 === n && e instanceof RegExp && !('flags' in Vc) ? Fc.call(e) : n)
          );
        },
        { unsafe: !0 }
      );
    var $c = Oa,
      qc = se,
      Gc = re('unscopables'),
      Wc = Array.prototype;
    null == Wc[Gc] && qc.f(Wc, Gc, { configurable: !0, value: $c(null) });
    var Zc = function (e) {
        Wc[Gc][e] = !0;
      },
      zc = pn.includes,
      Kc = Zc;
    Zn(
      { target: 'Array', proto: !0 },
      {
        includes: function (e) {
          return zc(this, e, arguments.length > 1 ? arguments[1] : void 0);
        },
      }
    ),
      Kc('includes');
    var Yc = le,
      Xc = Pt,
      Jc = re('match'),
      Qc = function (e) {
        var t;
        return Yc(e) && (void 0 !== (t = e[Jc]) ? !!t : 'RegExp' == Xc(e));
      },
      es = Qc,
      ts = function (e) {
        if (es(e)) throw TypeError("The method doesn't accept regular expressions");
        return e;
      },
      ns = re('match'),
      rs = function (e) {
        var t = /./;
        try {
          '/./'[e](t);
        } catch (n) {
          try {
            return (t[ns] = !1), '/./'[e](t);
          } catch (r) {}
        }
        return !1;
      },
      os = ts,
      is = S,
      as = na;
    Zn(
      { target: 'String', proto: !0, forced: !rs('includes') },
      {
        includes: function (e) {
          return !!~as(is(this)).indexOf(as(os(e)), arguments.length > 1 ? arguments[1] : void 0);
        },
      }
    );
    var cs = Pt,
      ss =
        Array.isArray ||
        function (e) {
          return 'Array' == cs(e);
        },
      ls = le,
      us = ss,
      fs = re('species'),
      hs = function (e) {
        var t;
        return (
          us(e) &&
            ('function' != typeof (t = e.constructor) || (t !== Array && !us(t.prototype))
              ? ls(t) && null === (t = t[fs]) && (t = void 0)
              : (t = void 0)),
          void 0 === t ? Array : t
        );
      },
      ps = function (e, t) {
        return new (hs(e))(0 === t ? 0 : t);
      },
      ds = gr,
      vs = Vt,
      ys = E,
      ms = rn,
      gs = ps,
      ws = [].push,
      bs = function (e) {
        var t = 1 == e,
          n = 2 == e,
          r = 3 == e,
          o = 4 == e,
          i = 6 == e,
          a = 7 == e,
          c = 5 == e || i;
        return function (s, l, u, f) {
          for (
            var h,
              p,
              d = ys(s),
              v = vs(d),
              y = ds(l, u, 3),
              m = ms(v.length),
              g = 0,
              w = f || gs,
              b = t ? w(s, m) : n || a ? w(s, 0) : void 0;
            m > g;
            g++
          )
            if ((c || g in v) && ((p = y((h = v[g]), g, d)), e))
              if (t) b[g] = p;
              else if (p)
                switch (e) {
                  case 3:
                    return !0;
                  case 5:
                    return h;
                  case 6:
                    return g;
                  case 2:
                    ws.call(b, h);
                }
              else
                switch (e) {
                  case 4:
                    return !1;
                  case 7:
                    ws.call(b, h);
                }
          return i ? -1 : r || o ? o : b;
        };
      },
      Ps = {
        forEach: bs(0),
        map: bs(1),
        filter: bs(2),
        some: bs(3),
        every: bs(4),
        find: bs(5),
        findIndex: bs(6),
        filterReject: bs(7),
      },
      Cs = Zn,
      Ss = Ps.find,
      xs = Zc,
      Es = 'find',
      ks = !0;
    Es in [] &&
      Array(1).find(function () {
        ks = !1;
      }),
      Cs(
        { target: 'Array', proto: !0, forced: ks },
        {
          find: function (e) {
            return Ss(this, e, arguments.length > 1 ? arguments[1] : void 0);
          },
        }
      ),
      xs(Es);
    var Os = E,
      Is = fa;
    Zn(
      {
        target: 'Object',
        stat: !0,
        forced: $(function () {
          Is(1);
        }),
      },
      {
        keys: function (e) {
          return Is(Os(e));
        },
      }
    );
    var As = me,
      Rs = rn,
      js = na,
      Ls = S,
      _s = lc,
      Us = mc;
    nc('match', function (e, t, n) {
      return [
        function (t) {
          var n = Ls(this),
            r = null == t ? void 0 : t[e];
          return void 0 !== r ? r.call(t, n) : new RegExp(t)[e](js(n));
        },
        function (e) {
          var r = As(this),
            o = js(e),
            i = n(t, r, o);
          if (i.done) return i.value;
          if (!r.global) return Us(r, o);
          var a = r.unicode;
          r.lastIndex = 0;
          for (var c, s = [], l = 0; null !== (c = Us(r, o)); ) {
            var u = js(c[0]);
            (s[l] = u), '' === u && (r.lastIndex = _s(o, Rs(r.lastIndex), a)), l++;
          }
          return 0 === l ? null : s;
        },
      ];
    });
    var Ts,
      Ms = (function () {
        function e() {
          a(this, e);
        }
        return (
          s(e, null, [
            {
              key: 'currentModel',
              value: function () {
                return this.getModel();
              },
            },
            {
              key: 'getModel',
              value: function () {
                var e = void 0;
                if (
                  (null == this.iosVer &&
                    (this.iosVer =
                      parseFloat(
                        (
                          '' +
                          (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(
                            navigator.userAgent
                          ) || [0, ''])[1]
                        )
                          .replace('undefined', '3_2')
                          .replace('_', '.')
                          .replace('_', '')
                      ) || !1),
                  this.iosVer >= 12.2)
                )
                  return Ts.IPhone_NotDetected;
                var t = window.devicePixelRatio;
                if (
                  (void 0 === this.canvasEl && (this.canvasEl = document.createElement('canvas')),
                  this.canvasEl)
                ) {
                  var n =
                    this.canvasEl.getContext('webgl') ||
                    this.canvasEl.getContext('experimental-webgl');
                  if (n) {
                    var r = n.getExtension('WEBGL_debug_renderer_info');
                    r && (e = n.getParameter(r.UNMASKED_RENDERER_WEBGL));
                  }
                }
                if (
                  896 === window.screen.height &&
                  414 === window.screen.width &&
                  (3 === window.devicePixelRatio || 2 === window.devicePixelRatio)
                )
                  return 3 === t ? Ts.IPhone_XS_Max : Ts.IPhone_XR;
                if (812 === window.screen.height && 375 === window.screen.width)
                  return 'Apple A12 GPU' === e ? Ts.IPhone_XS : Ts.IPhone_X;
                if (
                  736 === window.screen.height &&
                  414 === window.screen.width &&
                  3 === window.devicePixelRatio
                )
                  switch (e) {
                    default:
                      return Ts.IPhone_6_PLUS;
                    case 'Apple A9 GPU':
                      return Ts.IPhone_6S_PLUS;
                    case 'Apple A10 GPU':
                      return Ts.IPhone_7_PLUS;
                    case 'Apple A11 GPU':
                      return Ts.IPhone_8_PLUS;
                  }
                else if (
                  667 === window.screen.height &&
                  375 === window.screen.width &&
                  3 === window.devicePixelRatio
                )
                  switch (e) {
                    default:
                      return Ts.IPhone_6_PLUS;
                    case 'Apple A9 GPU':
                      return Ts.IPhone_6S_PLUS;
                    case 'Apple A10 GPU':
                      return Ts.IPhone_7_PLUS;
                    case 'Apple A11 GPU':
                      return Ts.IPhone_8_PLUS;
                  }
                else if (
                  667 === window.screen.height &&
                  375 === window.screen.width &&
                  2 === window.devicePixelRatio
                )
                  switch (e) {
                    default:
                      return Ts.IPhone_6;
                    case 'Apple A9 GPU':
                      return Ts.IPhone_6S;
                    case 'Apple A10 GPU':
                      return Ts.IPhone_7;
                    case 'Apple A11 GPU':
                      return Ts.IPhone_8;
                  }
                else if (
                  window.screen.height / window.screen.width == 1.775 &&
                  2 == window.devicePixelRatio
                )
                  switch (e) {
                    default:
                      return Ts.IPhone_5;
                    case 'Apple A7 GPU':
                      return Ts.IPhone_5S;
                    case 'Apple A8 GPU':
                      return Ts.IPhone_6;
                    case 'Apple A9 GPU':
                      return Ts.IPhone_SE;
                    case 'Apple A10 GPU':
                      return Ts.IPhone_7;
                    case 'Apple A11 GPU':
                      return Ts.IPhone_8;
                  }
                else {
                  if (
                    window.screen.height / window.screen.width == 1.5 &&
                    2 == window.devicePixelRatio
                  )
                    return 'PowerVR SGX 543' === e ? Ts.IPhone_4S : Ts.IPhone_4;
                  if (
                    window.screen.height / window.screen.width != 1.5 ||
                    1 != window.devicePixelRatio
                  )
                    return e && e.match('Apple') && this.iosVer ? Ts.IPhone : Ts.Not_IPhone;
                  switch (e) {
                    default:
                      return Ts.IPhone;
                    case 'ALP0298C05':
                      return Ts.IPhone_3GS;
                    case 'S5L8900':
                      return Ts.IPhone;
                  }
                }
              },
            },
          ]),
          e
        );
      })();
    l(Ms, 'iosVer', null),
      (function (e) {
        (e[(e.Not_IPhone = 0)] = 'Not_IPhone'),
          (e[(e.IPhone = 1)] = 'IPhone'),
          (e[(e.IPhone_3G = 3)] = 'IPhone_3G'),
          (e[(e.IPhone_3GS = 3.1)] = 'IPhone_3GS'),
          (e[(e.IPhone_4 = 4)] = 'IPhone_4'),
          (e[(e.IPhone_4S = 4.1)] = 'IPhone_4S'),
          (e[(e.IPhone_5 = 5)] = 'IPhone_5'),
          (e[(e.IPhone_5C = 5.1)] = 'IPhone_5C'),
          (e[(e.IPhone_5S = 5.2)] = 'IPhone_5S'),
          (e[(e.IPhone_SE = 6)] = 'IPhone_SE'),
          (e[(e.IPhone_6 = 6.1)] = 'IPhone_6'),
          (e[(e.IPhone_6_PLUS = 6.2)] = 'IPhone_6_PLUS'),
          (e[(e.IPhone_6S = 6.3)] = 'IPhone_6S'),
          (e[(e.IPhone_6S_PLUS = 6.4)] = 'IPhone_6S_PLUS'),
          (e[(e.IPhone_7 = 7)] = 'IPhone_7'),
          (e[(e.IPhone_7_PLUS = 7.1)] = 'IPhone_7_PLUS'),
          (e[(e.IPhone_8 = 8)] = 'IPhone_8'),
          (e[(e.IPhone_8_PLUS = 8.1)] = 'IPhone_8_PLUS'),
          (e[(e.IPhone_X = 10)] = 'IPhone_X'),
          (e[(e.IPhone_XR = 10.1)] = 'IPhone_XR'),
          (e[(e.IPhone_XS = 10.2)] = 'IPhone_XS'),
          (e[(e.IPhone_XS_Max = 10.3)] = 'IPhone_XS_Max'),
          (e[(e.IPhone_NotDetected = 1e6)] = 'IPhone_NotDetected');
      })(Ts || (Ts = {}));
    var Fs = (function () {
      function e() {
        a(this, e),
          (this.iPhoneVersion = Ms.currentModel()),
          (this.isIOs = null != navigator.userAgent.match(/(iPad|iPhone|iPod)/g)),
          (this.isAndroid = null != navigator.userAgent.match(/Android/g));
      }
      return (
        s(e, [
          {
            key: 'isIphone',
            get: function () {
              return this.iPhoneVersion != Ts.Not_IPhone;
            },
          },
        ]),
        e
      );
    })();
    !(function (e) {
      var t = (function (e) {
        var t,
          n = Object.prototype,
          r = n.hasOwnProperty,
          o = 'function' == typeof Symbol ? Symbol : {},
          i = o.iterator || '@@iterator',
          a = o.asyncIterator || '@@asyncIterator',
          c = o.toStringTag || '@@toStringTag';
        function s(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          s({}, '');
        } catch (j) {
          s = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function l(e, t, n, r) {
          var o = t && t.prototype instanceof y ? t : y,
            i = Object.create(o.prototype),
            a = new I(r || []);
          return (
            (i._invoke = (function (e, t, n) {
              var r = f;
              return function (o, i) {
                if (r === p) throw new Error('Generator is already running');
                if (r === d) {
                  if ('throw' === o) throw i;
                  return R();
                }
                for (n.method = o, n.arg = i; ; ) {
                  var a = n.delegate;
                  if (a) {
                    var c = E(a, n);
                    if (c) {
                      if (c === v) continue;
                      return c;
                    }
                  }
                  if ('next' === n.method) n.sent = n._sent = n.arg;
                  else if ('throw' === n.method) {
                    if (r === f) throw ((r = d), n.arg);
                    n.dispatchException(n.arg);
                  } else 'return' === n.method && n.abrupt('return', n.arg);
                  r = p;
                  var s = u(e, t, n);
                  if ('normal' === s.type) {
                    if (((r = n.done ? d : h), s.arg === v)) continue;
                    return { value: s.arg, done: n.done };
                  }
                  'throw' === s.type && ((r = d), (n.method = 'throw'), (n.arg = s.arg));
                }
              };
            })(e, n, a)),
            i
          );
        }
        function u(e, t, n) {
          try {
            return { type: 'normal', arg: e.call(t, n) };
          } catch (j) {
            return { type: 'throw', arg: j };
          }
        }
        e.wrap = l;
        var f = 'suspendedStart',
          h = 'suspendedYield',
          p = 'executing',
          d = 'completed',
          v = {};
        function y() {}
        function m() {}
        function g() {}
        var w = {};
        s(w, i, function () {
          return this;
        });
        var b = Object.getPrototypeOf,
          P = b && b(b(A([])));
        P && P !== n && r.call(P, i) && (w = P);
        var C = (g.prototype = y.prototype = Object.create(w));
        function S(e) {
          ['next', 'throw', 'return'].forEach(function (t) {
            s(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function x(e, t) {
          function n(o, i, a, c) {
            var s = u(e[o], e, i);
            if ('throw' !== s.type) {
              var l = s.arg,
                f = l.value;
              return f && 'object' == typeof f && r.call(f, '__await')
                ? t.resolve(f.__await).then(
                    function (e) {
                      n('next', e, a, c);
                    },
                    function (e) {
                      n('throw', e, a, c);
                    }
                  )
                : t.resolve(f).then(
                    function (e) {
                      (l.value = e), a(l);
                    },
                    function (e) {
                      return n('throw', e, a, c);
                    }
                  );
            }
            c(s.arg);
          }
          var o;
          this._invoke = function (e, r) {
            function i() {
              return new t(function (t, o) {
                n(e, r, t, o);
              });
            }
            return (o = o ? o.then(i, i) : i());
          };
        }
        function E(e, n) {
          var r = e.iterator[n.method];
          if (r === t) {
            if (((n.delegate = null), 'throw' === n.method)) {
              if (
                e.iterator.return &&
                ((n.method = 'return'), (n.arg = t), E(e, n), 'throw' === n.method)
              )
                return v;
              (n.method = 'throw'),
                (n.arg = new TypeError("The iterator does not provide a 'throw' method"));
            }
            return v;
          }
          var o = u(r, e.iterator, n.arg);
          if ('throw' === o.type)
            return (n.method = 'throw'), (n.arg = o.arg), (n.delegate = null), v;
          var i = o.arg;
          return i
            ? i.done
              ? ((n[e.resultName] = i.value),
                (n.next = e.nextLoc),
                'return' !== n.method && ((n.method = 'next'), (n.arg = t)),
                (n.delegate = null),
                v)
              : i
            : ((n.method = 'throw'),
              (n.arg = new TypeError('iterator result is not an object')),
              (n.delegate = null),
              v);
        }
        function k(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function O(e) {
          var t = e.completion || {};
          (t.type = 'normal'), delete t.arg, (e.completion = t);
        }
        function I(e) {
          (this.tryEntries = [{ tryLoc: 'root' }]), e.forEach(k, this), this.reset(!0);
        }
        function A(e) {
          if (e) {
            var n = e[i];
            if (n) return n.call(e);
            if ('function' == typeof e.next) return e;
            if (!isNaN(e.length)) {
              var o = -1,
                a = function n() {
                  for (; ++o < e.length; )
                    if (r.call(e, o)) return (n.value = e[o]), (n.done = !1), n;
                  return (n.value = t), (n.done = !0), n;
                };
              return (a.next = a);
            }
          }
          return { next: R };
        }
        function R() {
          return { value: t, done: !0 };
        }
        return (
          (m.prototype = g),
          s(C, 'constructor', g),
          s(g, 'constructor', m),
          (m.displayName = s(g, c, 'GeneratorFunction')),
          (e.isGeneratorFunction = function (e) {
            var t = 'function' == typeof e && e.constructor;
            return !!t && (t === m || 'GeneratorFunction' === (t.displayName || t.name));
          }),
          (e.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, g)
                : ((e.__proto__ = g), s(e, c, 'GeneratorFunction')),
              (e.prototype = Object.create(C)),
              e
            );
          }),
          (e.awrap = function (e) {
            return { __await: e };
          }),
          S(x.prototype),
          s(x.prototype, a, function () {
            return this;
          }),
          (e.AsyncIterator = x),
          (e.async = function (t, n, r, o, i) {
            void 0 === i && (i = Promise);
            var a = new x(l(t, n, r, o), i);
            return e.isGeneratorFunction(n)
              ? a
              : a.next().then(function (e) {
                  return e.done ? e.value : a.next();
                });
          }),
          S(C),
          s(C, c, 'Generator'),
          s(C, i, function () {
            return this;
          }),
          s(C, 'toString', function () {
            return '[object Generator]';
          }),
          (e.keys = function (e) {
            var t = [];
            for (var n in e) t.push(n);
            return (
              t.reverse(),
              function n() {
                for (; t.length; ) {
                  var r = t.pop();
                  if (r in e) return (n.value = r), (n.done = !1), n;
                }
                return (n.done = !0), n;
              }
            );
          }),
          (e.values = A),
          (I.prototype = {
            constructor: I,
            reset: function (e) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = t),
                (this.done = !1),
                (this.delegate = null),
                (this.method = 'next'),
                (this.arg = t),
                this.tryEntries.forEach(O),
                !e)
              )
                for (var n in this)
                  't' === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ('throw' === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var n = this;
              function o(r, o) {
                return (
                  (c.type = 'throw'),
                  (c.arg = e),
                  (n.next = r),
                  o && ((n.method = 'next'), (n.arg = t)),
                  !!o
                );
              }
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var a = this.tryEntries[i],
                  c = a.completion;
                if ('root' === a.tryLoc) return o('end');
                if (a.tryLoc <= this.prev) {
                  var s = r.call(a, 'catchLoc'),
                    l = r.call(a, 'finallyLoc');
                  if (s && l) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  } else if (s) {
                    if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                  } else {
                    if (!l) throw new Error('try statement without catch or finally');
                    if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var o = this.tryEntries[n];
                if (o.tryLoc <= this.prev && r.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
                  var i = o;
                  break;
                }
              }
              i &&
                ('break' === e || 'continue' === e) &&
                i.tryLoc <= t &&
                t <= i.finallyLoc &&
                (i = null);
              var a = i ? i.completion : {};
              return (
                (a.type = e),
                (a.arg = t),
                i ? ((this.method = 'next'), (this.next = i.finallyLoc), v) : this.complete(a)
              );
            },
            complete: function (e, t) {
              if ('throw' === e.type) throw e.arg;
              return (
                'break' === e.type || 'continue' === e.type
                  ? (this.next = e.arg)
                  : 'return' === e.type
                  ? ((this.rval = this.arg = e.arg), (this.method = 'return'), (this.next = 'end'))
                  : 'normal' === e.type && t && (this.next = t),
                v
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), O(n), v;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var r = n.completion;
                  if ('throw' === r.type) {
                    var o = r.arg;
                    O(n);
                  }
                  return o;
                }
              }
              throw new Error('illegal catch attempt');
            },
            delegateYield: function (e, n, r) {
              return (
                (this.delegate = { iterator: A(e), resultName: n, nextLoc: r }),
                'next' === this.method && (this.arg = t),
                v
              );
            },
          }),
          e
        );
      })(e.exports);
      try {
        regeneratorRuntime = t;
      } catch (n) {
        'object' == typeof globalThis
          ? (globalThis.regeneratorRuntime = t)
          : Function('r', 'regeneratorRuntime = r')(t);
      }
    })({ exports: {} });
    var Ns = Oe,
      Vs = se,
      Ds = _e,
      Hs = function (e, t, n) {
        var r = Ns(t);
        r in e ? Vs.f(e, r, Ds(0, n)) : (e[r] = n);
      },
      Bs = $,
      $s = B,
      qs = re('species'),
      Gs = function (e) {
        return (
          $s >= 51 ||
          !Bs(function () {
            var t = [];
            return (
              ((t.constructor = {})[qs] = function () {
                return { foo: 1 };
              }),
              1 !== t[e](Boolean).foo
            );
          })
        );
      },
      Ws = Zn,
      Zs = le,
      zs = ss,
      Ks = sn,
      Ys = rn,
      Xs = Bt,
      Js = Hs,
      Qs = re,
      el = Gs('slice'),
      tl = Qs('species'),
      nl = [].slice,
      rl = Math.max;
    Ws(
      { target: 'Array', proto: !0, forced: !el },
      {
        slice: function (e, t) {
          var n,
            r,
            o,
            i = Xs(this),
            a = Ys(i.length),
            c = Ks(e, a),
            s = Ks(void 0 === t ? a : t, a);
          if (
            zs(i) &&
            ('function' != typeof (n = i.constructor) || (n !== Array && !zs(n.prototype))
              ? Zs(n) && null === (n = n[tl]) && (n = void 0)
              : (n = void 0),
            n === Array || void 0 === n)
          )
            return nl.call(i, c, s);
          for (r = new (void 0 === n ? Array : n)(rl(s - c, 0)), o = 0; c < s; c++, o++)
            c in i && Js(r, o, i[c]);
          return (r.length = o), r;
        },
      }
    );
    var ol = '\t\n\v\f\r В бљЂвЂЂвЂЃвЂ‚вЂѓвЂ„вЂ…вЂ†вЂ‡вЂ€вЂ‰вЂЉвЂЇвЃџгЂЂ\u2028\u2029\ufeff',
      il = S,
      al = na,
      cl = '[\t\n\v\f\r В бљЂвЂЂвЂЃвЂ‚вЂѓвЂ„вЂ…вЂ†вЂ‡вЂ€вЂ‰вЂЉвЂЇвЃџгЂЂ\u2028\u2029\ufeff]',
      sl = RegExp('^' + cl + cl + '*'),
      ll = RegExp(cl + cl + '*$'),
      ul = function (e) {
        return function (t) {
          var n = al(il(t));
          return 1 & e && (n = n.replace(sl, '')), 2 & e && (n = n.replace(ll, '')), n;
        };
      },
      fl = { start: ul(1), end: ul(2), trim: ul(3) },
      hl = $,
      pl = ol,
      dl = fl.trim;
    Zn(
      {
        target: 'String',
        proto: !0,
        forced: (function (e) {
          return hl(function () {
            return !!pl[e]() || 'вЂ‹В…б Ћ' != 'вЂ‹В…б Ћ'[e]() || pl[e].name !== e;
          });
        })('trim'),
      },
      {
        trim: function () {
          return dl(this);
        },
      }
    );
    var vl = le,
      yl = er,
      ml = ce,
      gl = p,
      wl = Vn,
      bl = function (e, t, n) {
        var r, o;
        return (
          yl &&
            'function' == typeof (r = t.constructor) &&
            r !== n &&
            vl((o = r.prototype)) &&
            o !== n.prototype &&
            yl(e, o),
          e
        );
      },
      Pl = Me,
      Cl = se.f,
      Sl = Xt.f,
      xl = Qc,
      El = na,
      kl = oa,
      Ol = ia,
      Il = ae.exports,
      Al = $,
      Rl = I,
      jl = ft.enforce,
      Ll = lr,
      _l = Ra,
      Ul = _a,
      Tl = re('match'),
      Ml = gl.RegExp,
      Fl = Ml.prototype,
      Nl = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/,
      Vl = /a/g,
      Dl = /a/g,
      Hl = new Ml(Vl) !== Vl,
      Bl = Ol.UNSUPPORTED_Y,
      $l =
        ml &&
        (!Hl ||
          Bl ||
          _l ||
          Ul ||
          Al(function () {
            return (Dl[Tl] = !1), Ml(Vl) != Vl || Ml(Dl) == Dl || '/a/i' != Ml(Vl, 'i');
          }));
    if (wl('RegExp', $l)) {
      for (
        var ql = function (e, t) {
            var n,
              r,
              o,
              i,
              a,
              c,
              s = this instanceof ql,
              l = xl(e),
              u = void 0 === t,
              f = [],
              h = e;
            if (!s && l && u && e.constructor === ql) return e;
            if (
              ((l || e instanceof ql) &&
                ((e = e.source), u && (t = ('flags' in h) ? h.flags : kl.call(h))),
              (e = void 0 === e ? '' : El(e)),
              (t = void 0 === t ? '' : El(t)),
              (h = e),
              _l &&
                ('dotAll' in Vl) &&
                (r = !!t && t.indexOf('s') > -1) &&
                (t = t.replace(/s/g, '')),
              (n = t),
              Bl &&
                ('sticky' in Vl) &&
                (o = !!t && t.indexOf('y') > -1) &&
                (t = t.replace(/y/g, '')),
              Ul &&
                ((i = (function (e) {
                  for (
                    var t,
                      n = e.length,
                      r = 0,
                      o = '',
                      i = [],
                      a = {},
                      c = !1,
                      s = !1,
                      l = 0,
                      u = '';
                    r <= n;
                    r++
                  ) {
                    if ('\\' === (t = e.charAt(r))) t += e.charAt(++r);
                    else if (']' === t) c = !1;
                    else if (!c)
                      switch (!0) {
                        case '[' === t:
                          c = !0;
                          break;
                        case '(' === t:
                          Nl.test(e.slice(r + 1)) && ((r += 2), (s = !0)), (o += t), l++;
                          continue;
                        case '>' === t && s:
                          if ('' === u || Rl(a, u))
                            throw new SyntaxError('Invalid capture group name');
                          (a[u] = !0), i.push([u, l]), (s = !1), (u = '');
                          continue;
                      }
                    s ? (u += t) : (o += t);
                  }
                  return [o, i];
                })(e)),
                (e = i[0]),
                (f = i[1])),
              (a = bl(Ml(e, t), s ? this : Fl, ql)),
              (r || o || f.length) &&
                ((c = jl(a)),
                r &&
                  ((c.dotAll = !0),
                  (c.raw = ql(
                    (function (e) {
                      for (var t, n = e.length, r = 0, o = '', i = !1; r <= n; r++)
                        '\\' !== (t = e.charAt(r))
                          ? i || '.' !== t
                            ? ('[' === t ? (i = !0) : ']' === t && (i = !1), (o += t))
                            : (o += '[\\s\\S]')
                          : (o += t + e.charAt(++r));
                      return o;
                    })(e),
                    n
                  ))),
                o && (c.sticky = !0),
                f.length && (c.groups = f)),
              e !== h)
            )
              try {
                Pl(a, 'source', '' === h ? '(?:)' : h);
              } catch (lg) {}
            return a;
          },
          Gl = function (e) {
            (e in ql) ||
              Cl(ql, e, {
                configurable: !0,
                get: function () {
                  return Ml[e];
                },
                set: function (t) {
                  Ml[e] = t;
                },
              });
          },
          Wl = Sl(Ml),
          Zl = 0;
        Wl.length > Zl;

      )
        Gl(Wl[Zl++]);
      (Fl.constructor = ql), (ql.prototype = Fl), Il(gl, 'RegExp', ql);
    }
    Ll('RegExp');
    var zl = (1).valueOf,
      Kl = en,
      Yl = na,
      Xl = S,
      Jl = Zn,
      Ql = en,
      eu = function (e) {
        return zl.call(e);
      },
      tu = function (e) {
        var t = Yl(Xl(this)),
          n = '',
          r = Kl(e);
        if (r < 0 || r == 1 / 0) throw RangeError('Wrong number of repetitions');
        for (; r > 0; (r >>>= 1) && (t += t)) 1 & r && (n += t);
        return n;
      },
      nu = $,
      ru = (1).toFixed,
      ou = Math.floor,
      iu = function (e, t, n) {
        return 0 === t ? n : t % 2 == 1 ? iu(e, t - 1, n * e) : iu(e * e, t / 2, n);
      },
      au = function (e, t, n) {
        for (var r = -1, o = n; ++r < 6; ) (o += t * e[r]), (e[r] = o % 1e7), (o = ou(o / 1e7));
      },
      cu = function (e, t) {
        for (var n = 6, r = 0; --n >= 0; ) (r += e[n]), (e[n] = ou(r / t)), (r = (r % t) * 1e7);
      },
      su = function (e) {
        for (var t = 6, n = ''; --t >= 0; )
          if ('' !== n || 0 === t || 0 !== e[t]) {
            var r = String(e[t]);
            n = '' === n ? r : n + tu.call('0', 7 - r.length) + r;
          }
        return n;
      };
    Jl(
      {
        target: 'Number',
        proto: !0,
        forced:
          (ru &&
            ('0.000' !== (8e-5).toFixed(3) ||
              '1' !== (0.9).toFixed(0) ||
              '1.25' !== (1.255).toFixed(2) ||
              '1000000000000000128' !== (0xde0b6b3a7640080).toFixed(0))) ||
          !nu(function () {
            ru.call({});
          }),
      },
      {
        toFixed: function (e) {
          var t,
            n,
            r,
            o,
            i = eu(this),
            a = Ql(e),
            c = [0, 0, 0, 0, 0, 0],
            s = '',
            l = '0';
          if (a < 0 || a > 20) throw RangeError('Incorrect fraction digits');
          if (i != i) return 'NaN';
          if (i <= -1e21 || i >= 1e21) return String(i);
          if ((i < 0 && ((s = '-'), (i = -i)), i > 1e-21))
            if (
              ((n =
                (t =
                  (function (e) {
                    for (var t = 0, n = e; n >= 4096; ) (t += 12), (n /= 4096);
                    for (; n >= 2; ) (t += 1), (n /= 2);
                    return t;
                  })(i * iu(2, 69, 1)) - 69) < 0
                  ? i * iu(2, -t, 1)
                  : i / iu(2, t, 1)),
              (n *= 4503599627370496),
              (t = 52 - t) > 0)
            ) {
              for (au(c, 0, n), r = a; r >= 7; ) au(c, 1e7, 0), (r -= 7);
              for (au(c, iu(10, r, 1), 0), r = t - 1; r >= 23; ) cu(c, 1 << 23), (r -= 23);
              cu(c, 1 << r), au(c, 1, 1), cu(c, 2), (l = su(c));
            } else au(c, 0, n), au(c, 1 << -t, 0), (l = su(c) + tu.call('0', a));
          return (l =
            a > 0
              ? s +
                ((o = l.length) <= a
                  ? '0.' + tu.call('0', a - o) + l
                  : l.slice(0, o - a) + '.' + l.slice(o - a))
              : s + l);
        },
      }
    );
    var lu,
      uu = Zn,
      fu = Lt.f,
      hu = rn,
      pu = na,
      du = ts,
      vu = S,
      yu = rs,
      mu = ''.endsWith,
      gu = Math.min,
      wu = yu('endsWith');
    uu(
      {
        target: 'String',
        proto: !0,
        forced: !!(wu || ((lu = fu(String.prototype, 'endsWith')), !lu || lu.writable)) && !wu,
      },
      {
        endsWith: function (e) {
          var t = pu(vu(this));
          du(e);
          var n = arguments.length > 1 ? arguments[1] : void 0,
            r = hu(t.length),
            o = void 0 === n ? r : gu(hu(n), r),
            i = pu(e);
          return mu ? mu.call(t, i, o) : t.slice(o - i.length, o) === i;
        },
      }
    );
    var bu,
      Pu,
      Cu,
      Su = !$(function () {
        function e() {}
        return (e.prototype.constructor = null), Object.getPrototypeOf(new e()) !== e.prototype;
      }),
      xu = I,
      Eu = E,
      ku = Su,
      Ou = Ke('IE_PROTO'),
      Iu = Object.prototype,
      Au = ku
        ? Object.getPrototypeOf
        : function (e) {
            return (
              (e = Eu(e)),
              xu(e, Ou)
                ? e[Ou]
                : 'function' == typeof e.constructor && e instanceof e.constructor
                ? e.constructor.prototype
                : e instanceof Object
                ? Iu
                : null
            );
          },
      Ru = $,
      ju = Au,
      Lu = Me,
      _u = re('iterator'),
      Uu = !1;
    [].keys &&
      ('next' in (Cu = [].keys())
        ? (Pu = ju(ju(Cu))) !== Object.prototype && (bu = Pu)
        : (Uu = !0));
    var Tu =
      null == bu ||
      Ru(function () {
        var e = {};
        return bu[_u].call(e) !== e;
      });
    Tu && (bu = {}),
      'function' != typeof bu[_u] &&
        Lu(bu, _u, function () {
          return this;
        });
    var Mu = { IteratorPrototype: bu, BUGGY_SAFARI_ITERATORS: Uu },
      Fu = Mu.IteratorPrototype,
      Nu = Oa,
      Vu = _e,
      Du = or,
      Hu = hr,
      Bu = function () {
        return this;
      },
      $u = function (e, t, n) {
        var r = t + ' Iterator';
        return (e.prototype = Nu(Fu, { next: Vu(1, n) })), Du(e, r, !1), (Hu[r] = Bu), e;
      },
      qu = Zn,
      Gu = $u,
      Wu = Au,
      Zu = er,
      zu = or,
      Ku = Me,
      Yu = ae.exports,
      Xu = hr,
      Ju = Mu.IteratorPrototype,
      Qu = Mu.BUGGY_SAFARI_ITERATORS,
      ef = re('iterator'),
      tf = 'keys',
      nf = 'values',
      rf = 'entries',
      of = function () {
        return this;
      },
      af = function (e, t, n, r, o, i, a) {
        Gu(n, t, r);
        var c,
          s,
          l,
          u = function (e) {
            if (e === o && v) return v;
            if (!Qu && e in p) return p[e];
            switch (e) {
              case tf:
              case nf:
              case rf:
                return function () {
                  return new n(this, e);
                };
            }
            return function () {
              return new n(this);
            };
          },
          f = t + ' Iterator',
          h = !1,
          p = e.prototype,
          d = p[ef] || p['@@iterator'] || (o && p[o]),
          v = (!Qu && d) || u(o),
          y = ('Array' == t && p.entries) || d;
        if (
          (y &&
            (c = Wu(y.call(new e()))) !== Object.prototype &&
            c.next &&
            (Wu(c) !== Ju && (Zu ? Zu(c, Ju) : 'function' != typeof c[ef] && Ku(c, ef, of)),
            zu(c, f, !0)),
          o == nf &&
            d &&
            d.name !== nf &&
            ((h = !0),
            (v = function () {
              return d.call(this);
            })),
          p[ef] !== v && Ku(p, ef, v),
          (Xu[t] = v),
          o)
        )
          if (((s = { values: u(nf), keys: i ? v : u(tf), entries: u(rf) }), a))
            for (l in s) (Qu || h || !(l in p)) && Yu(p, l, s[l]);
          else qu({ target: t, proto: !0, forced: Qu || h }, s);
        return s;
      },
      cf = Bt,
      sf = Zc,
      lf = hr,
      uf = ft,
      ff = af,
      hf = 'Array Iterator',
      pf = uf.set,
      df = uf.getterFor(hf),
      vf = ff(
        Array,
        'Array',
        function (e, t) {
          pf(this, { type: hf, target: cf(e), index: 0, kind: t });
        },
        function () {
          var e = df(this),
            t = e.target,
            n = e.kind,
            r = e.index++;
          return !t || r >= t.length
            ? ((e.target = void 0), { value: void 0, done: !0 })
            : 'keys' == n
            ? { value: r, done: !1 }
            : 'values' == n
            ? { value: t[r], done: !1 }
            : { value: [r, t[r]], done: !1 };
        },
        'values'
      );
    (lf.Arguments = lf.Array), sf('keys'), sf('values'), sf('entries');
    var yf = cc.charAt,
      mf = na,
      gf = ft,
      wf = af,
      bf = 'String Iterator',
      Pf = gf.set,
      Cf = gf.getterFor(bf);
    wf(
      String,
      'String',
      function (e) {
        Pf(this, { type: bf, string: mf(e), index: 0 });
      },
      function () {
        var e,
          t = Cf(this),
          n = t.string,
          r = t.index;
        return r >= n.length
          ? { value: void 0, done: !0 }
          : ((e = yf(n, r)), (t.index += e.length), { value: e, done: !1 });
      }
    );
    var Sf = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0,
      },
      xf = pe('span').classList,
      Ef = xf && xf.constructor && xf.constructor.prototype,
      kf = Ef === Object.prototype ? void 0 : Ef,
      Of = p,
      If = Sf,
      Af = kf,
      Rf = vf,
      jf = Me,
      Lf = re,
      _f = Lf('iterator'),
      Uf = Lf('toStringTag'),
      Tf = Rf.values,
      Mf = function (e, t) {
        if (e) {
          if (e[_f] !== Tf)
            try {
              jf(e, _f, Tf);
            } catch (lg) {
              e[_f] = Tf;
            }
          if ((e[Uf] || jf(e, Uf, t), If[t]))
            for (var n in Rf)
              if (e[n] !== Rf[n])
                try {
                  jf(e, n, Rf[n]);
                } catch (lg) {
                  e[n] = Rf[n];
                }
        }
      };
    for (var Ff in If) Mf(Of[Ff] && Of[Ff].prototype, Ff);
    Mf(Af, 'DOMTokenList');
    var Nf = $,
      Vf = re('iterator'),
      Df = !Nf(function () {
        var e = new URL('b?a=1&b=2&c=3', 'http://a'),
          t = e.searchParams,
          n = '';
        return (
          (e.pathname = 'c%20d'),
          t.forEach(function (e, r) {
            t.delete('b'), (n += r + e);
          }),
          !t.sort ||
            'http://a/c%20d?a=1&c=3' !== e.href ||
            '3' !== t.get('c') ||
            'a=1' !== String(new URLSearchParams('?a=1')) ||
            !t[Vf] ||
            'a' !== new URL('https://a@b').username ||
            'b' !== new URLSearchParams(new URLSearchParams('a=b')).get('a') ||
            'xn--e1aybc' !== new URL('http://С‚РµСЃС‚').host ||
            '#%D0%B1' !== new URL('http://a#Р±').hash ||
            'a1c3' !== n ||
            'x' !== new URL('http://x', void 0).host
        );
      }),
      Hf = ce,
      Bf = $,
      $f = fa,
      qf = Cn,
      Gf = _t,
      Wf = E,
      Zf = Vt,
      zf = Object.assign,
      Kf = Object.defineProperty,
      Yf =
        !zf ||
        Bf(function () {
          if (
            Hf &&
            1 !==
              zf(
                { b: 1 },
                zf(
                  Kf({}, 'a', {
                    enumerable: !0,
                    get: function () {
                      Kf(this, 'b', { value: 3, enumerable: !1 });
                    },
                  }),
                  { b: 2 }
                )
              ).b
          )
            return !0;
          var e = {},
            t = {},
            n = Symbol(),
            r = 'abcdefghijklmnopqrst';
          return (
            (e[n] = 7),
            r.split('').forEach(function (e) {
              t[e] = e;
            }),
            7 != zf({}, e)[n] || $f(zf({}, t)).join('') != r
          );
        })
          ? function (e, t) {
              for (var n = Wf(e), r = arguments.length, o = 1, i = qf.f, a = Gf.f; r > o; )
                for (
                  var c,
                    s = Zf(arguments[o++]),
                    l = i ? $f(s).concat(i(s)) : $f(s),
                    u = l.length,
                    f = 0;
                  u > f;

                )
                  (c = l[f++]), (Hf && !a.call(s, c)) || (n[c] = s[c]);
              return n;
            }
          : zf,
      Xf = me,
      Jf = Or,
      Qf = gr,
      eh = E,
      th = function (e, t, n, r) {
        try {
          return r ? t(Xf(n)[0], n[1]) : t(n);
        } catch (lg) {
          Jf(e, 'throw', lg);
        }
      },
      nh = yr,
      rh = rn,
      oh = Hs,
      ih = Er,
      ah = Cr,
      ch = 2147483647,
      sh = /[^\0-\u007E]/,
      lh = /[.\u3002\uFF0E\uFF61]/g,
      uh = 'Overflow: input needs wider integers to process',
      fh = Math.floor,
      hh = String.fromCharCode,
      ph = function (e) {
        return e + 22 + 75 * (e < 26);
      },
      dh = function (e, t, n) {
        var r = 0;
        for (e = n ? fh(e / 700) : e >> 1, e += fh(e / t); e > 455; r += 36) e = fh(e / 35);
        return fh(r + (36 * e) / (e + 38));
      },
      vh = function (e) {
        var t = [];
        e = (function (e) {
          for (var t = [], n = 0, r = e.length; n < r; ) {
            var o = e.charCodeAt(n++);
            if (o >= 55296 && o <= 56319 && n < r) {
              var i = e.charCodeAt(n++);
              56320 == (64512 & i)
                ? t.push(((1023 & o) << 10) + (1023 & i) + 65536)
                : (t.push(o), n--);
            } else t.push(o);
          }
          return t;
        })(e);
        var n,
          r,
          o = e.length,
          i = 128,
          a = 0,
          c = 72;
        for (n = 0; n < e.length; n++) (r = e[n]) < 128 && t.push(hh(r));
        var s = t.length,
          l = s;
        for (s && t.push('-'); l < o; ) {
          var u = ch;
          for (n = 0; n < e.length; n++) (r = e[n]) >= i && r < u && (u = r);
          var f = l + 1;
          if (u - i > fh((ch - a) / f)) throw RangeError(uh);
          for (a += (u - i) * f, i = u, n = 0; n < e.length; n++) {
            if ((r = e[n]) < i && ++a > ch) throw RangeError(uh);
            if (r == i) {
              for (var h = a, p = 36; ; p += 36) {
                var d = p <= c ? 1 : p >= c + 26 ? 26 : p - c;
                if (h < d) break;
                var v = h - d,
                  y = 36 - d;
                t.push(hh(ph(d + (v % y)))), (h = fh(v / y));
              }
              t.push(hh(ph(h))), (c = dh(a, f, l == s)), (a = 0), ++l;
            }
          }
          ++a, ++i;
        }
        return t.join('');
      },
      yh = Zn,
      mh = U,
      gh = Df,
      wh = ae.exports,
      bh = Yn,
      Ph = or,
      Ch = $u,
      Sh = ft,
      xh = fr,
      Eh = I,
      kh = gr,
      Oh = kt,
      Ih = me,
      Ah = le,
      Rh = na,
      jh = Oa,
      Lh = _e,
      _h = Er,
      Uh = Cr,
      Th = re,
      Mh = mh('fetch'),
      Fh = mh('Request'),
      Nh = Fh && Fh.prototype,
      Vh = mh('Headers'),
      Dh = Th('iterator'),
      Hh = 'URLSearchParams',
      Bh = 'URLSearchParamsIterator',
      $h = Sh.set,
      qh = Sh.getterFor(Hh),
      Gh = Sh.getterFor(Bh),
      Wh = /\+/g,
      Zh = Array(4),
      zh = function (e) {
        return Zh[e - 1] || (Zh[e - 1] = RegExp('((?:%[\\da-f]{2}){' + e + '})', 'gi'));
      },
      Kh = function (e) {
        try {
          return decodeURIComponent(e);
        } catch (lg) {
          return e;
        }
      },
      Yh = function (e) {
        var t = e.replace(Wh, ' '),
          n = 4;
        try {
          return decodeURIComponent(t);
        } catch (lg) {
          for (; n; ) t = t.replace(zh(n--), Kh);
          return t;
        }
      },
      Xh = /[!'()~]|%20/g,
      Jh = { '!': '%21', "'": '%27', '(': '%28', ')': '%29', '~': '%7E', '%20': '+' },
      Qh = function (e) {
        return Jh[e];
      },
      ep = function (e) {
        return encodeURIComponent(e).replace(Xh, Qh);
      },
      tp = function (e, t) {
        if (t)
          for (var n, r, o = t.split('&'), i = 0; i < o.length; )
            (n = o[i++]).length &&
              ((r = n.split('=')), e.push({ key: Yh(r.shift()), value: Yh(r.join('=')) }));
      },
      np = function (e) {
        (this.entries.length = 0), tp(this.entries, e);
      },
      rp = function (e, t) {
        if (e < t) throw TypeError('Not enough arguments');
      },
      op = Ch(
        function (e, t) {
          $h(this, { type: Bh, iterator: _h(qh(e).entries), kind: t });
        },
        'Iterator',
        function () {
          var e = Gh(this),
            t = e.kind,
            n = e.iterator.next(),
            r = n.value;
          return (
            n.done ||
              (n.value = 'keys' === t ? r.key : 'values' === t ? r.value : [r.key, r.value]),
            n
          );
        }
      ),
      ip = function () {
        xh(this, ip, Hh);
        var e,
          t,
          n,
          r,
          o,
          i,
          a,
          c,
          s,
          l = arguments.length > 0 ? arguments[0] : void 0,
          u = this,
          f = [];
        if (
          ($h(u, { type: Hh, entries: f, updateURL: function () {}, updateSearchParams: np }),
          void 0 !== l)
        )
          if (Ah(l))
            if ('function' == typeof (e = Uh(l)))
              for (n = (t = _h(l, e)).next; !(r = n.call(t)).done; ) {
                if (
                  (a = (i = (o = _h(Ih(r.value))).next).call(o)).done ||
                  (c = i.call(o)).done ||
                  !i.call(o).done
                )
                  throw TypeError('Expected sequence with length 2');
                f.push({ key: Rh(a.value), value: Rh(c.value) });
              }
            else for (s in l) Eh(l, s) && f.push({ key: s, value: Rh(l[s]) });
          else tp(f, 'string' == typeof l ? ('?' === l.charAt(0) ? l.slice(1) : l) : Rh(l));
      },
      ap = ip.prototype;
    if (
      (bh(
        ap,
        {
          append: function (e, t) {
            rp(arguments.length, 2);
            var n = qh(this);
            n.entries.push({ key: Rh(e), value: Rh(t) }), n.updateURL();
          },
          delete: function (e) {
            rp(arguments.length, 1);
            for (var t = qh(this), n = t.entries, r = Rh(e), o = 0; o < n.length; )
              n[o].key === r ? n.splice(o, 1) : o++;
            t.updateURL();
          },
          get: function (e) {
            rp(arguments.length, 1);
            for (var t = qh(this).entries, n = Rh(e), r = 0; r < t.length; r++)
              if (t[r].key === n) return t[r].value;
            return null;
          },
          getAll: function (e) {
            rp(arguments.length, 1);
            for (var t = qh(this).entries, n = Rh(e), r = [], o = 0; o < t.length; o++)
              t[o].key === n && r.push(t[o].value);
            return r;
          },
          has: function (e) {
            rp(arguments.length, 1);
            for (var t = qh(this).entries, n = Rh(e), r = 0; r < t.length; )
              if (t[r++].key === n) return !0;
            return !1;
          },
          set: function (e, t) {
            rp(arguments.length, 1);
            for (
              var n, r = qh(this), o = r.entries, i = !1, a = Rh(e), c = Rh(t), s = 0;
              s < o.length;
              s++
            )
              (n = o[s]).key === a && (i ? o.splice(s--, 1) : ((i = !0), (n.value = c)));
            i || o.push({ key: a, value: c }), r.updateURL();
          },
          sort: function () {
            var e,
              t,
              n,
              r = qh(this),
              o = r.entries,
              i = o.slice();
            for (o.length = 0, n = 0; n < i.length; n++) {
              for (e = i[n], t = 0; t < n; t++)
                if (o[t].key > e.key) {
                  o.splice(t, 0, e);
                  break;
                }
              t === n && o.push(e);
            }
            r.updateURL();
          },
          forEach: function (e) {
            for (
              var t,
                n = qh(this).entries,
                r = kh(e, arguments.length > 1 ? arguments[1] : void 0, 3),
                o = 0;
              o < n.length;

            )
              r((t = n[o++]).value, t.key, this);
          },
          keys: function () {
            return new op(this, 'keys');
          },
          values: function () {
            return new op(this, 'values');
          },
          entries: function () {
            return new op(this, 'entries');
          },
        },
        { enumerable: !0 }
      ),
      wh(ap, Dh, ap.entries),
      wh(
        ap,
        'toString',
        function () {
          for (var e, t = qh(this).entries, n = [], r = 0; r < t.length; )
            (e = t[r++]), n.push(ep(e.key) + '=' + ep(e.value));
          return n.join('&');
        },
        { enumerable: !0 }
      ),
      Ph(ip, Hh),
      yh({ global: !0, forced: !gh }, { URLSearchParams: ip }),
      !gh && 'function' == typeof Vh)
    ) {
      var cp = function (e) {
        if (Ah(e)) {
          var t,
            n = e.body;
          if (Oh(n) === Hh)
            return (
              (t = e.headers ? new Vh(e.headers) : new Vh()).has('content-type') ||
                t.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8'),
              jh(e, { body: Lh(0, String(n)), headers: Lh(0, t) })
            );
        }
        return e;
      };
      if (
        ('function' == typeof Mh &&
          yh(
            { global: !0, enumerable: !0, forced: !0 },
            {
              fetch: function (e) {
                return Mh(e, arguments.length >= 1 ? cp(arguments[1]) : {});
              },
            }
          ),
        'function' == typeof Fh)
      ) {
        var sp = function (e) {
          return xh(this, sp, 'Request'), new Fh(e, arguments.length > 1 ? cp(arguments[1]) : {});
        };
        (Nh.constructor = sp), (sp.prototype = Nh), yh({ global: !0, forced: !0 }, { Request: sp });
      }
    }
    var lp,
      up = { URLSearchParams: ip, getState: qh },
      fp = Zn,
      hp = ce,
      pp = Df,
      dp = p,
      vp = va,
      yp = ae.exports,
      mp = fr,
      gp = I,
      wp = Yf,
      bp = function (e) {
        var t,
          n,
          r,
          o,
          i,
          a,
          c = eh(e),
          s = 'function' == typeof this ? this : Array,
          l = arguments.length,
          u = l > 1 ? arguments[1] : void 0,
          f = void 0 !== u,
          h = ah(c),
          p = 0;
        if (
          (f && (u = Qf(u, l > 2 ? arguments[2] : void 0, 2)), null == h || (s == Array && nh(h)))
        )
          for (n = new s((t = rh(c.length))); t > p; p++) (a = f ? u(c[p], p) : c[p]), oh(n, p, a);
        else
          for (i = (o = ih(c, h)).next, n = new s(); !(r = i.call(o)).done; p++)
            (a = f ? th(o, u, [r.value, p], !0) : r.value), oh(n, p, a);
        return (n.length = p), n;
      },
      Pp = cc.codeAt,
      Cp = function (e) {
        var t,
          n,
          r = [],
          o = e.toLowerCase().replace(lh, '.').split('.');
        for (t = 0; t < o.length; t++) (n = o[t]), r.push(sh.test(n) ? 'xn--' + vh(n) : n);
        return r.join('.');
      },
      Sp = na,
      xp = or,
      Ep = up,
      kp = ft,
      Op = dp.URL,
      Ip = Ep.URLSearchParams,
      Ap = Ep.getState,
      Rp = kp.set,
      jp = kp.getterFor('URL'),
      Lp = Math.floor,
      _p = Math.pow,
      Up = 'Invalid scheme',
      Tp = 'Invalid host',
      Mp = 'Invalid port',
      Fp = /[A-Za-z]/,
      Np = /[\d+-.A-Za-z]/,
      Vp = /\d/,
      Dp = /^0x/i,
      Hp = /^[0-7]+$/,
      Bp = /^\d+$/,
      $p = /^[\dA-Fa-f]+$/,
      qp = /[\0\t\n\r #%/:<>?@[\\\]^|]/,
      Gp = /[\0\t\n\r #/:<>?@[\\\]^|]/,
      Wp = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g,
      Zp = /[\t\n\r]/g,
      zp = function (e, t) {
        var n, r, o;
        if ('[' == t.charAt(0)) {
          if (']' != t.charAt(t.length - 1)) return Tp;
          if (!(n = Yp(t.slice(1, -1)))) return Tp;
          e.host = n;
        } else if (od(e)) {
          if (((t = Cp(t)), qp.test(t))) return Tp;
          if (null === (n = Kp(t))) return Tp;
          e.host = n;
        } else {
          if (Gp.test(t)) return Tp;
          for (n = '', r = bp(t), o = 0; o < r.length; o++) n += nd(r[o], Jp);
          e.host = n;
        }
      },
      Kp = function (e) {
        var t,
          n,
          r,
          o,
          i,
          a,
          c,
          s = e.split('.');
        if ((s.length && '' == s[s.length - 1] && s.pop(), (t = s.length) > 4)) return e;
        for (n = [], r = 0; r < t; r++) {
          if ('' == (o = s[r])) return e;
          if (
            ((i = 10),
            o.length > 1 &&
              '0' == o.charAt(0) &&
              ((i = Dp.test(o) ? 16 : 8), (o = o.slice(8 == i ? 1 : 2))),
            '' === o)
          )
            a = 0;
          else {
            if (!(10 == i ? Bp : 8 == i ? Hp : $p).test(o)) return e;
            a = parseInt(o, i);
          }
          n.push(a);
        }
        for (r = 0; r < t; r++)
          if (((a = n[r]), r == t - 1)) {
            if (a >= _p(256, 5 - t)) return null;
          } else if (a > 255) return null;
        for (c = n.pop(), r = 0; r < n.length; r++) c += n[r] * _p(256, 3 - r);
        return c;
      },
      Yp = function (e) {
        var t,
          n,
          r,
          o,
          i,
          a,
          c,
          s = [0, 0, 0, 0, 0, 0, 0, 0],
          l = 0,
          u = null,
          f = 0,
          h = function () {
            return e.charAt(f);
          };
        if (':' == h()) {
          if (':' != e.charAt(1)) return;
          (f += 2), (u = ++l);
        }
        for (; h(); ) {
          if (8 == l) return;
          if (':' != h()) {
            for (t = n = 0; n < 4 && $p.test(h()); ) (t = 16 * t + parseInt(h(), 16)), f++, n++;
            if ('.' == h()) {
              if (0 == n) return;
              if (((f -= n), l > 6)) return;
              for (r = 0; h(); ) {
                if (((o = null), r > 0)) {
                  if (!('.' == h() && r < 4)) return;
                  f++;
                }
                if (!Vp.test(h())) return;
                for (; Vp.test(h()); ) {
                  if (((i = parseInt(h(), 10)), null === o)) o = i;
                  else {
                    if (0 == o) return;
                    o = 10 * o + i;
                  }
                  if (o > 255) return;
                  f++;
                }
                (s[l] = 256 * s[l] + o), (2 != ++r && 4 != r) || l++;
              }
              if (4 != r) return;
              break;
            }
            if (':' == h()) {
              if ((f++, !h())) return;
            } else if (h()) return;
            s[l++] = t;
          } else {
            if (null !== u) return;
            f++, (u = ++l);
          }
        }
        if (null !== u)
          for (a = l - u, l = 7; 0 != l && a > 0; )
            (c = s[l]), (s[l--] = s[u + a - 1]), (s[u + --a] = c);
        else if (8 != l) return;
        return s;
      },
      Xp = function (e) {
        var t, n, r, o;
        if ('number' == typeof e) {
          for (t = [], n = 0; n < 4; n++) t.unshift(e % 256), (e = Lp(e / 256));
          return t.join('.');
        }
        if ('object' == typeof e) {
          for (
            t = '',
              r = (function (e) {
                for (var t = null, n = 1, r = null, o = 0, i = 0; i < 8; i++)
                  0 !== e[i]
                    ? (o > n && ((t = r), (n = o)), (r = null), (o = 0))
                    : (null === r && (r = i), ++o);
                return o > n && ((t = r), (n = o)), t;
              })(e),
              n = 0;
            n < 8;
            n++
          )
            (o && 0 === e[n]) ||
              (o && (o = !1),
              r === n
                ? ((t += n ? ':' : '::'), (o = !0))
                : ((t += e[n].toString(16)), n < 7 && (t += ':')));
          return '[' + t + ']';
        }
        return e;
      },
      Jp = {},
      Qp = wp({}, Jp, { ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1 }),
      ed = wp({}, Qp, { '#': 1, '?': 1, '{': 1, '}': 1 }),
      td = wp({}, ed, {
        '/': 1,
        ':': 1,
        ';': 1,
        '=': 1,
        '@': 1,
        '[': 1,
        '\\': 1,
        ']': 1,
        '^': 1,
        '|': 1,
      }),
      nd = function (e, t) {
        var n = Pp(e, 0);
        return n > 32 && n < 127 && !gp(t, e) ? e : encodeURIComponent(e);
      },
      rd = { ftp: 21, file: null, http: 80, https: 443, ws: 80, wss: 443 },
      od = function (e) {
        return gp(rd, e.scheme);
      },
      id = function (e) {
        return '' != e.username || '' != e.password;
      },
      ad = function (e) {
        return !e.host || e.cannotBeABaseURL || 'file' == e.scheme;
      },
      cd = function (e, t) {
        var n;
        return (
          2 == e.length && Fp.test(e.charAt(0)) && (':' == (n = e.charAt(1)) || (!t && '|' == n))
        );
      },
      sd = function (e) {
        var t;
        return (
          e.length > 1 &&
          cd(e.slice(0, 2)) &&
          (2 == e.length || '/' === (t = e.charAt(2)) || '\\' === t || '?' === t || '#' === t)
        );
      },
      ld = function (e) {
        var t = e.path,
          n = t.length;
        !n || ('file' == e.scheme && 1 == n && cd(t[0], !0)) || t.pop();
      },
      ud = function (e) {
        return '.' === e || '%2e' === e.toLowerCase();
      },
      fd = {},
      hd = {},
      pd = {},
      dd = {},
      vd = {},
      yd = {},
      md = {},
      gd = {},
      wd = {},
      bd = {},
      Pd = {},
      Cd = {},
      Sd = {},
      xd = {},
      Ed = {},
      kd = {},
      Od = {},
      Id = {},
      Ad = {},
      Rd = {},
      jd = {},
      Ld = function (e, t, n, r) {
        var o,
          i,
          a,
          c,
          s,
          l = n || fd,
          u = 0,
          f = '',
          h = !1,
          p = !1,
          d = !1;
        for (
          n ||
            ((e.scheme = ''),
            (e.username = ''),
            (e.password = ''),
            (e.host = null),
            (e.port = null),
            (e.path = []),
            (e.query = null),
            (e.fragment = null),
            (e.cannotBeABaseURL = !1),
            (t = t.replace(Wp, ''))),
            t = t.replace(Zp, ''),
            o = bp(t);
          u <= o.length;

        ) {
          switch (((i = o[u]), l)) {
            case fd:
              if (!i || !Fp.test(i)) {
                if (n) return Up;
                l = pd;
                continue;
              }
              (f += i.toLowerCase()), (l = hd);
              break;
            case hd:
              if (i && (Np.test(i) || '+' == i || '-' == i || '.' == i)) f += i.toLowerCase();
              else {
                if (':' != i) {
                  if (n) return Up;
                  (f = ''), (l = pd), (u = 0);
                  continue;
                }
                if (
                  n &&
                  (od(e) != gp(rd, f) ||
                    ('file' == f && (id(e) || null !== e.port)) ||
                    ('file' == e.scheme && !e.host))
                )
                  return;
                if (((e.scheme = f), n))
                  return void (od(e) && rd[e.scheme] == e.port && (e.port = null));
                (f = ''),
                  'file' == e.scheme
                    ? (l = xd)
                    : od(e) && r && r.scheme == e.scheme
                    ? (l = dd)
                    : od(e)
                    ? (l = gd)
                    : '/' == o[u + 1]
                    ? ((l = vd), u++)
                    : ((e.cannotBeABaseURL = !0), e.path.push(''), (l = Ad));
              }
              break;
            case pd:
              if (!r || (r.cannotBeABaseURL && '#' != i)) return Up;
              if (r.cannotBeABaseURL && '#' == i) {
                (e.scheme = r.scheme),
                  (e.path = r.path.slice()),
                  (e.query = r.query),
                  (e.fragment = ''),
                  (e.cannotBeABaseURL = !0),
                  (l = jd);
                break;
              }
              l = 'file' == r.scheme ? xd : yd;
              continue;
            case dd:
              if ('/' != i || '/' != o[u + 1]) {
                l = yd;
                continue;
              }
              (l = wd), u++;
              break;
            case vd:
              if ('/' == i) {
                l = bd;
                break;
              }
              l = Id;
              continue;
            case yd:
              if (((e.scheme = r.scheme), i == lp))
                (e.username = r.username),
                  (e.password = r.password),
                  (e.host = r.host),
                  (e.port = r.port),
                  (e.path = r.path.slice()),
                  (e.query = r.query);
              else if ('/' == i || ('\\' == i && od(e))) l = md;
              else if ('?' == i)
                (e.username = r.username),
                  (e.password = r.password),
                  (e.host = r.host),
                  (e.port = r.port),
                  (e.path = r.path.slice()),
                  (e.query = ''),
                  (l = Rd);
              else {
                if ('#' != i) {
                  (e.username = r.username),
                    (e.password = r.password),
                    (e.host = r.host),
                    (e.port = r.port),
                    (e.path = r.path.slice()),
                    e.path.pop(),
                    (l = Id);
                  continue;
                }
                (e.username = r.username),
                  (e.password = r.password),
                  (e.host = r.host),
                  (e.port = r.port),
                  (e.path = r.path.slice()),
                  (e.query = r.query),
                  (e.fragment = ''),
                  (l = jd);
              }
              break;
            case md:
              if (!od(e) || ('/' != i && '\\' != i)) {
                if ('/' != i) {
                  (e.username = r.username),
                    (e.password = r.password),
                    (e.host = r.host),
                    (e.port = r.port),
                    (l = Id);
                  continue;
                }
                l = bd;
              } else l = wd;
              break;
            case gd:
              if (((l = wd), '/' != i || '/' != f.charAt(u + 1))) continue;
              u++;
              break;
            case wd:
              if ('/' != i && '\\' != i) {
                l = bd;
                continue;
              }
              break;
            case bd:
              if ('@' == i) {
                h && (f = '%40' + f), (h = !0), (a = bp(f));
                for (var v = 0; v < a.length; v++) {
                  var y = a[v];
                  if (':' != y || d) {
                    var m = nd(y, td);
                    d ? (e.password += m) : (e.username += m);
                  } else d = !0;
                }
                f = '';
              } else if (i == lp || '/' == i || '?' == i || '#' == i || ('\\' == i && od(e))) {
                if (h && '' == f) return 'Invalid authority';
                (u -= bp(f).length + 1), (f = ''), (l = Pd);
              } else f += i;
              break;
            case Pd:
            case Cd:
              if (n && 'file' == e.scheme) {
                l = kd;
                continue;
              }
              if (':' != i || p) {
                if (i == lp || '/' == i || '?' == i || '#' == i || ('\\' == i && od(e))) {
                  if (od(e) && '' == f) return Tp;
                  if (n && '' == f && (id(e) || null !== e.port)) return;
                  if ((c = zp(e, f))) return c;
                  if (((f = ''), (l = Od), n)) return;
                  continue;
                }
                '[' == i ? (p = !0) : ']' == i && (p = !1), (f += i);
              } else {
                if ('' == f) return Tp;
                if ((c = zp(e, f))) return c;
                if (((f = ''), (l = Sd), n == Cd)) return;
              }
              break;
            case Sd:
              if (!Vp.test(i)) {
                if (i == lp || '/' == i || '?' == i || '#' == i || ('\\' == i && od(e)) || n) {
                  if ('' != f) {
                    var g = parseInt(f, 10);
                    if (g > 65535) return Mp;
                    (e.port = od(e) && g === rd[e.scheme] ? null : g), (f = '');
                  }
                  if (n) return;
                  l = Od;
                  continue;
                }
                return Mp;
              }
              f += i;
              break;
            case xd:
              if (((e.scheme = 'file'), '/' == i || '\\' == i)) l = Ed;
              else {
                if (!r || 'file' != r.scheme) {
                  l = Id;
                  continue;
                }
                if (i == lp) (e.host = r.host), (e.path = r.path.slice()), (e.query = r.query);
                else if ('?' == i)
                  (e.host = r.host), (e.path = r.path.slice()), (e.query = ''), (l = Rd);
                else {
                  if ('#' != i) {
                    sd(o.slice(u).join('')) ||
                      ((e.host = r.host), (e.path = r.path.slice()), ld(e)),
                      (l = Id);
                    continue;
                  }
                  (e.host = r.host),
                    (e.path = r.path.slice()),
                    (e.query = r.query),
                    (e.fragment = ''),
                    (l = jd);
                }
              }
              break;
            case Ed:
              if ('/' == i || '\\' == i) {
                l = kd;
                break;
              }
              r &&
                'file' == r.scheme &&
                !sd(o.slice(u).join('')) &&
                (cd(r.path[0], !0) ? e.path.push(r.path[0]) : (e.host = r.host)),
                (l = Id);
              continue;
            case kd:
              if (i == lp || '/' == i || '\\' == i || '?' == i || '#' == i) {
                if (!n && cd(f)) l = Id;
                else if ('' == f) {
                  if (((e.host = ''), n)) return;
                  l = Od;
                } else {
                  if ((c = zp(e, f))) return c;
                  if (('localhost' == e.host && (e.host = ''), n)) return;
                  (f = ''), (l = Od);
                }
                continue;
              }
              f += i;
              break;
            case Od:
              if (od(e)) {
                if (((l = Id), '/' != i && '\\' != i)) continue;
              } else if (n || '?' != i)
                if (n || '#' != i) {
                  if (i != lp && ((l = Id), '/' != i)) continue;
                } else (e.fragment = ''), (l = jd);
              else (e.query = ''), (l = Rd);
              break;
            case Id:
              if (i == lp || '/' == i || ('\\' == i && od(e)) || (!n && ('?' == i || '#' == i))) {
                if (
                  ('..' === (s = (s = f).toLowerCase()) ||
                  '%2e.' === s ||
                  '.%2e' === s ||
                  '%2e%2e' === s
                    ? (ld(e), '/' == i || ('\\' == i && od(e)) || e.path.push(''))
                    : ud(f)
                    ? '/' == i || ('\\' == i && od(e)) || e.path.push('')
                    : ('file' == e.scheme &&
                        !e.path.length &&
                        cd(f) &&
                        (e.host && (e.host = ''), (f = f.charAt(0) + ':')),
                      e.path.push(f)),
                  (f = ''),
                  'file' == e.scheme && (i == lp || '?' == i || '#' == i))
                )
                  for (; e.path.length > 1 && '' === e.path[0]; ) e.path.shift();
                '?' == i ? ((e.query = ''), (l = Rd)) : '#' == i && ((e.fragment = ''), (l = jd));
              } else f += nd(i, ed);
              break;
            case Ad:
              '?' == i
                ? ((e.query = ''), (l = Rd))
                : '#' == i
                ? ((e.fragment = ''), (l = jd))
                : i != lp && (e.path[0] += nd(i, Jp));
              break;
            case Rd:
              n || '#' != i
                ? i != lp &&
                  ("'" == i && od(e)
                    ? (e.query += '%27')
                    : (e.query += '#' == i ? '%23' : nd(i, Jp)))
                : ((e.fragment = ''), (l = jd));
              break;
            case jd:
              i != lp && (e.fragment += nd(i, Qp));
          }
          u++;
        }
      },
      _d = function (e) {
        var t,
          n,
          r = mp(this, _d, 'URL'),
          o = arguments.length > 1 ? arguments[1] : void 0,
          i = Sp(e),
          a = Rp(r, { type: 'URL' });
        if (void 0 !== o)
          if (o instanceof _d) t = jp(o);
          else if ((n = Ld((t = {}), Sp(o)))) throw TypeError(n);
        if ((n = Ld(a, i, null, t))) throw TypeError(n);
        var c = (a.searchParams = new Ip()),
          s = Ap(c);
        s.updateSearchParams(a.query),
          (s.updateURL = function () {
            a.query = String(c) || null;
          }),
          hp ||
            ((r.href = Td.call(r)),
            (r.origin = Md.call(r)),
            (r.protocol = Fd.call(r)),
            (r.username = Nd.call(r)),
            (r.password = Vd.call(r)),
            (r.host = Dd.call(r)),
            (r.hostname = Hd.call(r)),
            (r.port = Bd.call(r)),
            (r.pathname = $d.call(r)),
            (r.search = qd.call(r)),
            (r.searchParams = Gd.call(r)),
            (r.hash = Wd.call(r)));
      },
      Ud = _d.prototype,
      Td = function () {
        var e = jp(this),
          t = e.scheme,
          n = e.username,
          r = e.password,
          o = e.host,
          i = e.port,
          a = e.path,
          c = e.query,
          s = e.fragment,
          l = t + ':';
        return (
          null !== o
            ? ((l += '//'),
              id(e) && (l += n + (r ? ':' + r : '') + '@'),
              (l += Xp(o)),
              null !== i && (l += ':' + i))
            : 'file' == t && (l += '//'),
          (l += e.cannotBeABaseURL ? a[0] : a.length ? '/' + a.join('/') : ''),
          null !== c && (l += '?' + c),
          null !== s && (l += '#' + s),
          l
        );
      },
      Md = function () {
        var e = jp(this),
          t = e.scheme,
          n = e.port;
        if ('blob' == t)
          try {
            return new _d(t.path[0]).origin;
          } catch (lg) {
            return 'null';
          }
        return 'file' != t && od(e) ? t + '://' + Xp(e.host) + (null !== n ? ':' + n : '') : 'null';
      },
      Fd = function () {
        return jp(this).scheme + ':';
      },
      Nd = function () {
        return jp(this).username;
      },
      Vd = function () {
        return jp(this).password;
      },
      Dd = function () {
        var e = jp(this),
          t = e.host,
          n = e.port;
        return null === t ? '' : null === n ? Xp(t) : Xp(t) + ':' + n;
      },
      Hd = function () {
        var e = jp(this).host;
        return null === e ? '' : Xp(e);
      },
      Bd = function () {
        var e = jp(this).port;
        return null === e ? '' : String(e);
      },
      $d = function () {
        var e = jp(this),
          t = e.path;
        return e.cannotBeABaseURL ? t[0] : t.length ? '/' + t.join('/') : '';
      },
      qd = function () {
        var e = jp(this).query;
        return e ? '?' + e : '';
      },
      Gd = function () {
        return jp(this).searchParams;
      },
      Wd = function () {
        var e = jp(this).fragment;
        return e ? '#' + e : '';
      },
      Zd = function (e, t) {
        return { get: e, set: t, configurable: !0, enumerable: !0 };
      };
    if (
      (hp &&
        vp(Ud, {
          href: Zd(Td, function (e) {
            var t = jp(this),
              n = Sp(e),
              r = Ld(t, n);
            if (r) throw TypeError(r);
            Ap(t.searchParams).updateSearchParams(t.query);
          }),
          origin: Zd(Md),
          protocol: Zd(Fd, function (e) {
            var t = jp(this);
            Ld(t, Sp(e) + ':', fd);
          }),
          username: Zd(Nd, function (e) {
            var t = jp(this),
              n = bp(Sp(e));
            if (!ad(t)) {
              t.username = '';
              for (var r = 0; r < n.length; r++) t.username += nd(n[r], td);
            }
          }),
          password: Zd(Vd, function (e) {
            var t = jp(this),
              n = bp(Sp(e));
            if (!ad(t)) {
              t.password = '';
              for (var r = 0; r < n.length; r++) t.password += nd(n[r], td);
            }
          }),
          host: Zd(Dd, function (e) {
            var t = jp(this);
            t.cannotBeABaseURL || Ld(t, Sp(e), Pd);
          }),
          hostname: Zd(Hd, function (e) {
            var t = jp(this);
            t.cannotBeABaseURL || Ld(t, Sp(e), Cd);
          }),
          port: Zd(Bd, function (e) {
            var t = jp(this);
            ad(t) || ('' == (e = Sp(e)) ? (t.port = null) : Ld(t, e, Sd));
          }),
          pathname: Zd($d, function (e) {
            var t = jp(this);
            t.cannotBeABaseURL || ((t.path = []), Ld(t, Sp(e), Od));
          }),
          search: Zd(qd, function (e) {
            var t = jp(this);
            '' == (e = Sp(e))
              ? (t.query = null)
              : ('?' == e.charAt(0) && (e = e.slice(1)), (t.query = ''), Ld(t, e, Rd)),
              Ap(t.searchParams).updateSearchParams(t.query);
          }),
          searchParams: Zd(Gd),
          hash: Zd(Wd, function (e) {
            var t = jp(this);
            '' != (e = Sp(e))
              ? ('#' == e.charAt(0) && (e = e.slice(1)), (t.fragment = ''), Ld(t, e, jd))
              : (t.fragment = null);
          }),
        }),
      yp(
        Ud,
        'toJSON',
        function () {
          return Td.call(this);
        },
        { enumerable: !0 }
      ),
      yp(
        Ud,
        'toString',
        function () {
          return Td.call(this);
        },
        { enumerable: !0 }
      ),
      Op)
    ) {
      var zd = Op.createObjectURL,
        Kd = Op.revokeObjectURL;
      zd &&
        yp(_d, 'createObjectURL', function (e) {
          return zd.apply(Op, arguments);
        }),
        Kd &&
          yp(_d, 'revokeObjectURL', function (e) {
            return Kd.apply(Op, arguments);
          });
    }
    xp(_d, 'URL'), fp({ global: !0, forced: !pp, sham: !hp }, { URL: _d });
    var Yd,
      Xd = (function () {
        function e() {
          a(this, e);
        }
        var t;
        return (
          s(e, null, [
            {
              key: 'isNullOrUndefined',
              value: function (e) {
                return null == e;
              },
            },
            {
              key: 'generateUuid',
              value: function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 36,
                  t = new Date().getTime(),
                  n =
                    ('undefined' != typeof performance &&
                      performance.now &&
                      1e3 * performance.now()) ||
                    0;
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
                  .replace(/[xy]/g, function (e) {
                    var r = 16 * Math.random();
                    return (
                      t > 0
                        ? ((r = (t + r) % 16 | 0), (t = Math.floor(t / 16)))
                        : ((r = (n + r) % 16 | 0), (n = Math.floor(n / 16))),
                      ('x' === e ? r : (3 & r) | 8).toString(16)
                    );
                  })
                  .slice(0, e);
              },
            },
            {
              key: 'removeClass',
              value: function (e, t) {
                for (var n = e.className; -1 != n.indexOf(t); ) n = (n = n.replace(t, '')).trim();
                e.className = n;
              },
            },
            {
              key: 'hideHtmlElement',
              value: function (e) {
                (e.style.opacity = '0'), (e.style.display = 'none');
              },
            },
            {
              key: 'showHtmlElement',
              value: function (e) {
                var t = this;
                (e.style.display = ''),
                  (e.style.opacity = '0'),
                  setTimeout(
                    function () {
                      u(this, t), (e.style.opacity = '1');
                    }.bind(this),
                    15
                  );
              },
            },
            {
              key: 'addClass',
              value: function (e, t) {
                e.className += ' ' + t;
              },
            },
            {
              key: 'loadScript',
              value:
                ((t = i(
                  regeneratorRuntime.mark(function e(t) {
                    var n = this;
                    return regeneratorRuntime.wrap(
                      function (e) {
                        for (;;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return e.abrupt(
                                'return',
                                new Promise(
                                  function (e, r) {
                                    var o = this;
                                    u(this, n);
                                    var i = document.createElement('script');
                                    (i.type = 'text/javascript'),
                                      (i.src = t),
                                      i.addEventListener(
                                        'load',
                                        function () {
                                          return u(this, o), e();
                                        }.bind(this),
                                        !1
                                      ),
                                      i.addEventListener(
                                        'error',
                                        function () {
                                          return u(this, o), r();
                                        }.bind(this),
                                        !1
                                      ),
                                      document.body.appendChild(i);
                                  }.bind(this)
                                )
                              );
                            case 1:
                            case 'end':
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                )),
                function (e) {
                  return t.apply(this, arguments);
                }),
            },
            {
              key: 'getCurrencySymbol',
              value: function (e) {
                switch (e) {
                  case 'RUB':
                    return 'в‚Ѕ';
                  case 'EUR':
                    return 'в‚¬';
                  case 'USD':
                    return '$';
                  case 'GBP':
                    return 'ВЈ';
                  case 'UAH':
                    return 'в‚ґ';
                  case 'BYR':
                    return 'Br';
                  case 'KZT':
                    return 'в‚ё';
                  case 'AZN':
                    return 'в‚ј';
                  case 'CHF':
                    return 'в‚Ј';
                  case 'CZK':
                    return 'KДЌ';
                  case 'CAD':
                    return 'C$';
                  case 'PLN':
                    return 'zЕ‚';
                  case 'SEK':
                    return 'kr';
                  case 'TRY':
                    return 'в‚є';
                  case 'CNY':
                    return 'ВҐ';
                  case 'INR':
                    return 'в‚№';
                  case 'BRL':
                    return 'R$';
                  case 'UZS':
                    return "So'm";
                  case 'BGN':
                    return 'Р»РІ';
                  case 'AUD':
                    return 'AU$';
                  case 'HKD':
                    return 'HK$';
                  case 'GEL':
                    return 'в‚ѕ';
                  case 'AMD':
                    return 'ЦЏ';
                  case 'AED':
                    return 'Dhs';
                  default:
                    return e;
                }
              },
            },
            {
              key: 'isIE',
              value: function () {
                var e = window.navigator.userAgent,
                  t = e.indexOf('MSIE '),
                  n = e.indexOf('Trident/');
                return t > 0 || n > 0;
              },
            },
            {
              key: 'getQueryParameterByName',
              value: function (e) {
                var t =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : window.location.href;
                e = e.replace(/[[\]]/g, '\\$&');
                var n = new RegExp('[?&]' + e + '(=([^&#]*)|&|#|$)'),
                  r = n.exec(t);
                return r && r[2] ? decodeURIComponent(r[2].replace(/\+/g, ' ')) : null;
              },
            },
            {
              key: 'getHostnameFromUrl',
              value: function (e) {
                var t = e.match(/^https?:\/\/([^/?#]+)(?:[/?#]|$)/i);
                return t && t[1];
              },
            },
          ]),
          e
        );
      })();
    function Jd(e) {
      var t = e.createElement('div');
      (t.id = 'cloudpayments-loading-overlay-63456123'),
        (t.style.cssText =
          'position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; text-align: center; background-color: transparent; z-index: 9999; display: flex; justify-content: center; align-items: center;');
      var n = new DOMParser(),
        r = n.parseFromString(
          '<svg\n  id="cloudpayments-loading-overlay-loader-63456123"\n  width="160"\n  height="161"\n  viewBox="0 0 160 161"\n  fill="none"\n  xmlns="http://www.w3.org/2000/svg"\n>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M72.4733 44.0599C73.156 46.1609 72.0061 48.4175 69.9051 49.1002C64.1755 50.9618 59.0723 54.3717 55.1598 58.9527C51.2472 63.5338 48.6776 69.1075 47.7352 75.0578C46.7928 81.0081 47.5142 87.1031 49.8196 92.669C52.1251 98.2349 55.9248 103.055 60.7987 106.596C65.6726 110.137 71.4308 112.261 77.4367 112.734C83.4426 113.207 89.4622 112.009 94.8301 109.274C100.198 106.539 104.705 102.373 107.853 97.2363C111 92.0996 112.666 86.1925 112.666 80.168C112.666 77.9589 114.457 76.168 116.666 76.168C118.875 76.168 120.666 77.9589 120.666 80.168C120.666 87.6679 118.592 95.0216 114.674 101.416C110.755 107.811 105.144 112.997 98.462 116.402C91.7796 119.807 84.2857 121.298 76.809 120.709C69.3323 120.121 62.1639 117.476 56.0964 113.068C50.0289 108.66 45.2987 102.659 42.4286 95.7305C39.5585 88.8015 38.6605 81.2139 39.8337 73.8063C41.0069 66.3988 44.2058 59.4601 49.0765 53.7571C53.9473 48.0542 60.3002 43.8093 67.433 41.4917C69.534 40.8091 71.7906 41.9589 72.4733 44.0599Z"\n    fill="#2E71FC"\n  />\n</svg>',
          'image/svg+xml'
        ).firstChild,
        o = n.parseFromString(
          '<svg width="48" height="40" viewBox="0 0 48 40" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <mask id="mask0_3499_115599" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="4" y="34" width="6" height="6">\n  <path d="M4.98779 34.0278H9.05139V40H4.98779V34.0278Z" fill="white"/>\n  </mask>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.22264 36.1387C8.22264 35.3665 7.72839 34.8221 7.03052 34.8221C6.33264 34.8221 5.80201 35.3665 5.80201 36.1387C5.80201 36.9182 6.33264 37.4552 7.03052 37.4552C7.72108 37.4552 8.22264 36.9182 8.22264 36.1387ZM9.05139 36.1387C9.05139 37.3743 8.27355 38.2496 7.20489 38.2496C6.57976 38.2496 6.10005 37.9406 5.80923 37.4847V40H4.98779V34.1161H5.80923V34.8074C6.10005 34.3442 6.57976 34.0278 7.2123 34.0278C8.25902 34.0278 9.05139 34.903 9.05139 36.1387Z" fill="#2E71FC"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8167 36.1387C12.8167 35.3665 12.286 34.8221 11.5882 34.8221C10.8903 34.8221 10.396 35.3665 10.396 36.1387C10.396 36.9182 10.8976 37.4552 11.5882 37.4552C12.286 37.4552 12.8167 36.9182 12.8167 36.1387ZM13.6309 34.1161V38.1613H12.8094V37.4847C12.5186 37.9479 12.0388 38.2496 11.4137 38.2496C10.3451 38.2496 9.56738 37.3743 9.56738 36.1387C9.56738 34.903 10.3598 34.0278 11.4065 34.0278C12.0388 34.0278 12.5186 34.3442 12.8094 34.8074V34.1161H13.6309Z" fill="#2E71FC"/>\n  <mask id="mask1_3499_115599" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="14" y="34" width="5" height="6">\n  <path d="M14.1035 34.1162H18.1526V40H14.1035V34.1162Z" fill="white"/>\n  </mask>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.1526 34.1162L15.5065 40.0001H14.6269L15.681 37.6465L14.1035 34.1162H14.9832L16.1172 36.7493L17.2729 34.1162H18.1526Z" fill="#2E71FC"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M24.6295 35.5649V38.1612H23.8081V35.7414C23.8081 35.1384 23.5682 34.8221 23.0157 34.8221C22.3687 34.8221 22.0343 35.3296 22.0343 36.065L22.0415 38.1612H21.2128V35.7414C21.2128 35.1384 20.973 34.8221 20.4205 34.8221C19.7735 34.8221 19.4464 35.3296 19.4464 36.065V38.1612H18.625V34.116H19.4464V34.7632C19.7226 34.3 20.1152 34.0278 20.6895 34.0278C21.3001 34.0278 21.729 34.3294 21.9253 34.8736C22.1943 34.3514 22.6449 34.0278 23.2773 34.0278C24.1206 34.0278 24.6295 34.6014 24.6295 35.5649Z" fill="#2E71FC"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M26.1193 35.69H28.4455C28.322 35.1384 27.9076 34.7486 27.3042 34.7486C26.6791 34.7486 26.2575 35.1458 26.1193 35.69ZM29.3251 36.3666H26.0757C26.1412 37.1095 26.6573 37.5215 27.3261 37.5215C27.8059 37.5215 28.2057 37.3155 28.3946 36.9182H29.2452C28.9326 37.8229 28.1693 38.2495 27.3188 38.2495C26.1049 38.2495 25.2397 37.3669 25.2397 36.146C25.2397 34.9251 26.0975 34.0278 27.3042 34.0278C28.5909 34.0278 29.4051 35.0354 29.3251 36.3666Z" fill="#2E71FC"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M33.5411 35.609V38.1612H32.7196V35.7783C32.7196 35.1531 32.4507 34.822 31.8474 34.822C31.1422 34.822 30.7642 35.2855 30.7642 36.065V38.1612H29.9429V34.116H30.7642V34.7853C31.0478 34.3146 31.4766 34.0278 32.1017 34.0278C33.0031 34.0278 33.5411 34.6235 33.5411 35.609Z" fill="#2E71FC"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M37.2628 37.9555C37.0448 38.0878 36.5795 38.2496 36.1215 38.2496C35.3001 38.2496 34.6603 37.7273 34.6603 36.6095V34.8958H33.9189V34.1163H34.6603V33.1968L35.4818 33.0129V34.1163H37.1247V34.8958H35.4818V36.5654C35.4818 37.1538 35.7508 37.4774 36.2669 37.4774C36.5213 37.4774 36.8049 37.3892 37.1174 37.2788L37.2628 37.9555Z" fill="#2E71FC"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M37.5464 36.8594H38.3824C38.5059 37.3081 38.833 37.514 39.5236 37.514C40.0543 37.514 40.3814 37.3522 40.3814 37.0505C40.3814 36.7124 40.0034 36.6608 39.3347 36.499C38.2151 36.2196 37.7427 35.9915 37.7427 35.3149C37.7427 34.4984 38.426 34.0278 39.4292 34.0278C40.454 34.0278 41.0284 34.5206 41.1738 35.256H40.345C40.2288 34.925 39.9234 34.7632 39.4145 34.7632C38.8839 34.7632 38.5714 34.9471 38.5714 35.2266C38.5714 35.484 38.8185 35.5502 39.5164 35.7193C40.5996 35.9768 41.2247 36.168 41.2247 36.955C41.2247 37.8229 40.454 38.2495 39.509 38.2495C38.455 38.2495 37.699 37.7346 37.5464 36.8594Z" fill="#2E71FC"/>\n  <mask id="mask2_3499_115599" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="21">\n  <path d="M0.172852 0H47.8267V20.141H0.172852V0Z" fill="white"/>\n  </mask>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.44865 20.141C3.20144 16.2326 6.59105 13.3265 10.6477 13.3265C12.3553 13.3265 13.9986 13.8572 15.3727 14.8102L16.9796 13.1845C15.7199 12.2358 14.2627 11.577 12.7141 11.2647C13.1827 6.18933 17.4024 2.26943 22.4887 2.26943C24.4977 2.26943 26.4288 2.87882 28.0733 4.03169C29.5012 5.03271 30.6286 6.37917 31.3643 7.95169C29.4083 8.47228 27.5929 9.4434 26.0652 10.7883L27.6563 12.3981C29.6046 10.7307 32.0948 9.78312 34.7001 9.78312C40.489 9.78312 45.2361 14.3194 45.5802 20.141H47.8267C47.6595 16.7419 46.2295 13.5726 43.7944 11.2109C41.3362 8.8267 38.1064 7.51369 34.7001 7.51369C34.3457 7.51369 33.9933 7.52958 33.6431 7.55829C32.756 5.37796 31.2758 3.51584 29.3507 2.16632C27.3293 0.749109 24.9564 0 22.4887 0C16.2382 0 11.053 4.81988 10.4804 11.0591C5.25908 11.1405 0.943871 15.0179 0.172852 20.141H2.44865Z" fill="#2E71FC"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.64355 26.4045C4.64355 24.1178 6.32125 22.3782 8.62319 22.3782C10.481 22.3782 12.1311 23.5146 12.4224 25.4786H10.3841C10.1483 24.6369 9.42736 24.23 8.62319 24.23C7.41673 24.23 6.64034 25.1279 6.654 26.4045C6.64034 27.6953 7.44452 28.579 8.60924 28.579C9.42736 28.579 10.1483 28.1581 10.3841 27.3165H12.4224C12.1172 29.3507 10.4396 30.4309 8.60924 30.4309C6.32125 30.4309 4.64355 28.6913 4.64355 26.4045Z" fill="#393962"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3511 30.2624H15.3339V20.1506H13.3511V30.2624Z" fill="#393962"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.3845 26.4045C18.3845 27.6811 19.2441 28.523 20.3534 28.523C21.4625 28.523 22.3224 27.6811 22.3224 26.4045C22.3224 25.1419 21.4625 24.2861 20.3534 24.2861C19.2441 24.2861 18.3845 25.1419 18.3845 26.4045ZM24.3329 26.4045C24.3329 28.7335 22.5858 30.4309 20.3534 30.4309C18.1347 30.4309 16.3877 28.7194 16.3877 26.4045C16.3877 24.0756 18.1626 22.3782 20.3534 22.3782C22.558 22.3782 24.3329 24.0756 24.3329 26.4045Z" fill="#393962"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3604 22.5464V30.2624H30.3776V29.1962C29.8228 29.9818 29.0742 30.4307 28.0204 30.4307C26.3425 30.4307 25.3027 29.2663 25.3027 27.3865V22.5464H27.2856V26.9516C27.2856 27.9616 27.6599 28.5228 28.6859 28.5228C29.7814 28.5228 30.3776 27.8635 30.3776 26.6009V22.5464H32.3604Z" fill="#393962"/>\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M39.3904 26.4044C39.3904 25.1418 38.5445 24.2859 37.4354 24.2859C36.326 24.2859 35.5079 25.1418 35.5079 26.4044C35.5079 27.681 36.34 28.5229 37.4354 28.5229C38.5445 28.5229 39.3904 27.681 39.3904 26.4044ZM41.3733 20.1506V30.2625H39.3904V29.2243C38.8636 29.9538 38.0594 30.4308 36.9915 30.4308C35.0087 30.4308 33.5112 28.7753 33.5112 26.4044C33.5112 24.0194 35.0226 22.378 36.9777 22.378C38.0594 22.378 38.8636 22.883 39.3904 23.6267V20.1506H41.3733Z" fill="#393962"/>\n  </svg>    \n',
          'image/svg+xml'
        ).firstChild;
      o.style.cssText =
        'position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);';
      var i = e.createElement('span');
      i.appendChild(r),
        (i.style.cssText =
          'position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);');
      var a = e.createElement('style');
      a.type = 'text/css';
      a.appendChild(
        e.createTextNode(
          '@-webkit-keyframes rotating /* Safari and Chrome */ {\n              from {\n                -webkit-transform: rotate(0deg);\n                -o-transform: rotate(0deg);\n                transform: rotate(0deg);\n              }\n              to {\n                -webkit-transform: rotate(360deg);\n                -o-transform: rotate(360deg);\n                transform: rotate(360deg);\n              }\n            }\n            @keyframes rotating {\n              from {\n                -ms-transform: rotate(0deg);\n                -moz-transform: rotate(0deg);\n                -webkit-transform: rotate(0deg);\n                -o-transform: rotate(0deg);\n                transform: rotate(0deg);\n              }\n              to {\n                -ms-transform: rotate(360deg);\n                -moz-transform: rotate(360deg);\n                -webkit-transform: rotate(360deg);\n                -o-transform: rotate(360deg);\n                transform: rotate(360deg);\n              }\n            }\n            #cloudpayments-loading-overlay-63456123 #cloudpayments-loading-overlay-loader-63456123{\n              -webkit-animation: rotating 2s linear infinite;\n              -moz-animation: rotating 2s linear infinite;\n              -ms-animation: rotating 2s linear infinite;\n              -o-animation: rotating 2s linear infinite;\n              animation: rotating 2s linear infinite;\n            }\n            '
        )
      ),
        t.appendChild(a),
        t.appendChild(o),
        t.appendChild(i),
        e.body.appendChild(t);
    }
    !(function (e) {
      (e.Auth = 'auth'), (e.Charge = 'charge');
    })(Yd || (Yd = {}));
    var Qd = {},
      ev = Bt,
      tv = Xt.f,
      nv = {}.toString,
      rv =
        'object' == typeof window && window && Object.getOwnPropertyNames
          ? Object.getOwnPropertyNames(window)
          : [];
    Qd.f = function (e) {
      return rv && '[object Window]' == nv.call(e)
        ? (function (e) {
            try {
              return tv(e);
            } catch (lg) {
              return rv.slice();
            }
          })(e)
        : tv(ev(e));
    };
    var ov = {},
      iv = re;
    ov.f = iv;
    var av = p,
      cv = I,
      sv = ov,
      lv = se.f,
      uv = Zn,
      fv = p,
      hv = U,
      pv = ce,
      dv = W,
      vv = $,
      yv = I,
      mv = ss,
      gv = le,
      wv = we,
      bv = me,
      Pv = E,
      Cv = Bt,
      Sv = Oe,
      xv = na,
      Ev = _e,
      kv = Oa,
      Ov = fa,
      Iv = Xt,
      Av = Qd,
      Rv = Cn,
      jv = Lt,
      Lv = se,
      _v = _t,
      Uv = Me,
      Tv = ae.exports,
      Mv = d.exports,
      Fv = Ye,
      Nv = j,
      Vv = re,
      Dv = ov,
      Hv = function (e) {
        var t = av.Symbol || (av.Symbol = {});
        cv(t, e) || lv(t, e, { value: sv.f(e) });
      },
      Bv = or,
      $v = ft,
      qv = Ps.forEach,
      Gv = Ke('hidden'),
      Wv = 'Symbol',
      Zv = Vv('toPrimitive'),
      zv = $v.set,
      Kv = $v.getterFor(Wv),
      Yv = Object.prototype,
      Xv = fv.Symbol,
      Jv = hv('JSON', 'stringify'),
      Qv = jv.f,
      ey = Lv.f,
      ty = Av.f,
      ny = _v.f,
      ry = Mv('symbols'),
      oy = Mv('op-symbols'),
      iy = Mv('string-to-symbol-registry'),
      ay = Mv('symbol-to-string-registry'),
      cy = Mv('wks'),
      sy = fv.QObject,
      ly = !sy || !sy.prototype || !sy.prototype.findChild,
      uy =
        pv &&
        vv(function () {
          return (
            7 !=
            kv(
              ey({}, 'a', {
                get: function () {
                  return ey(this, 'a', { value: 7 }).a;
                },
              })
            ).a
          );
        })
          ? function (e, t, n) {
              var r = Qv(Yv, t);
              r && delete Yv[t], ey(e, t, n), r && e !== Yv && ey(Yv, t, r);
            }
          : ey,
      fy = function (e, t) {
        var n = (ry[e] = kv(Xv.prototype));
        return zv(n, { type: Wv, tag: e, description: t }), pv || (n.description = t), n;
      },
      hy = function (e, t, n) {
        e === Yv && hy(oy, t, n), bv(e);
        var r = Sv(t);
        return (
          bv(n),
          yv(ry, r)
            ? (n.enumerable
                ? (yv(e, Gv) && e[Gv][r] && (e[Gv][r] = !1), (n = kv(n, { enumerable: Ev(0, !1) })))
                : (yv(e, Gv) || ey(e, Gv, Ev(1, {})), (e[Gv][r] = !0)),
              uy(e, r, n))
            : ey(e, r, n)
        );
      },
      py = function (e, t) {
        bv(e);
        var n = Cv(t),
          r = Ov(n).concat(my(n));
        return (
          qv(r, function (t) {
            (pv && !dy.call(n, t)) || hy(e, t, n[t]);
          }),
          e
        );
      },
      dy = function (e) {
        var t = Sv(e),
          n = ny.call(this, t);
        return (
          !(this === Yv && yv(ry, t) && !yv(oy, t)) &&
          (!(n || !yv(this, t) || !yv(ry, t) || (yv(this, Gv) && this[Gv][t])) || n)
        );
      },
      vy = function (e, t) {
        var n = Cv(e),
          r = Sv(t);
        if (n !== Yv || !yv(ry, r) || yv(oy, r)) {
          var o = Qv(n, r);
          return !o || !yv(ry, r) || (yv(n, Gv) && n[Gv][r]) || (o.enumerable = !0), o;
        }
      },
      yy = function (e) {
        var t = ty(Cv(e)),
          n = [];
        return (
          qv(t, function (e) {
            yv(ry, e) || yv(Fv, e) || n.push(e);
          }),
          n
        );
      },
      my = function (e) {
        var t = e === Yv,
          n = ty(t ? oy : Cv(e)),
          r = [];
        return (
          qv(n, function (e) {
            !yv(ry, e) || (t && !yv(Yv, e)) || r.push(ry[e]);
          }),
          r
        );
      };
    (dv ||
      ((Xv = function () {
        if (this instanceof Xv) throw TypeError('Symbol is not a constructor');
        var e = arguments.length && void 0 !== arguments[0] ? xv(arguments[0]) : void 0,
          t = Nv(e),
          n = function (e) {
            this === Yv && n.call(oy, e),
              yv(this, Gv) && yv(this[Gv], t) && (this[Gv][t] = !1),
              uy(this, t, Ev(1, e));
          };
        return pv && ly && uy(Yv, t, { configurable: !0, set: n }), fy(t, e);
      }),
      Tv(Xv.prototype, 'toString', function () {
        return Kv(this).tag;
      }),
      Tv(Xv, 'withoutSetter', function (e) {
        return fy(Nv(e), e);
      }),
      (_v.f = dy),
      (Lv.f = hy),
      (jv.f = vy),
      (Iv.f = Av.f = yy),
      (Rv.f = my),
      (Dv.f = function (e) {
        return fy(Vv(e), e);
      }),
      pv &&
        (ey(Xv.prototype, 'description', {
          configurable: !0,
          get: function () {
            return Kv(this).description;
          },
        }),
        Tv(Yv, 'propertyIsEnumerable', dy, { unsafe: !0 }))),
    uv({ global: !0, wrap: !0, forced: !dv, sham: !dv }, { Symbol: Xv }),
    qv(Ov(cy), function (e) {
      Hv(e);
    }),
    uv(
      { target: Wv, stat: !0, forced: !dv },
      {
        for: function (e) {
          var t = xv(e);
          if (yv(iy, t)) return iy[t];
          var n = Xv(t);
          return (iy[t] = n), (ay[n] = t), n;
        },
        keyFor: function (e) {
          if (!wv(e)) throw TypeError(e + ' is not a symbol');
          if (yv(ay, e)) return ay[e];
        },
        useSetter: function () {
          ly = !0;
        },
        useSimple: function () {
          ly = !1;
        },
      }
    ),
    uv(
      { target: 'Object', stat: !0, forced: !dv, sham: !pv },
      {
        create: function (e, t) {
          return void 0 === t ? kv(e) : py(kv(e), t);
        },
        defineProperty: hy,
        defineProperties: py,
        getOwnPropertyDescriptor: vy,
      }
    ),
    uv(
      { target: 'Object', stat: !0, forced: !dv },
      { getOwnPropertyNames: yy, getOwnPropertySymbols: my }
    ),
    uv(
      {
        target: 'Object',
        stat: !0,
        forced: vv(function () {
          Rv.f(1);
        }),
      },
      {
        getOwnPropertySymbols: function (e) {
          return Rv.f(Pv(e));
        },
      }
    ),
    Jv) &&
      uv(
        {
          target: 'JSON',
          stat: !0,
          forced:
            !dv ||
            vv(function () {
              var e = Xv();
              return '[null]' != Jv([e]) || '{}' != Jv({ a: e }) || '{}' != Jv(Object(e));
            }),
        },
        {
          stringify: function (e, t, n) {
            for (var r, o = [e], i = 1; arguments.length > i; ) o.push(arguments[i++]);
            if (((r = t), (gv(t) || void 0 !== e) && !wv(e)))
              return (
                mv(t) ||
                  (t = function (e, t) {
                    if (('function' == typeof r && (t = r.call(this, e, t)), !wv(t))) return t;
                  }),
                (o[1] = t),
                Jv.apply(null, o)
              );
          },
        }
      );
    Xv.prototype[Zv] || Uv(Xv.prototype, Zv, Xv.prototype.valueOf), Bv(Xv, Wv), (Fv[Gv] = !0);
    var gy = Zn,
      wy = ce,
      by = p,
      Py = I,
      Cy = le,
      Sy = se.f,
      xy = jn,
      Ey = by.Symbol;
    if (
      wy &&
      'function' == typeof Ey &&
      (!('description' in Ey.prototype) || void 0 !== Ey().description)
    ) {
      var ky = {},
        Oy = function () {
          var e = arguments.length < 1 || void 0 === arguments[0] ? void 0 : String(arguments[0]),
            t = this instanceof Oy ? new Ey(e) : void 0 === e ? Ey() : Ey(e);
          return '' === e && (ky[t] = !0), t;
        };
      xy(Oy, Ey);
      var Iy = (Oy.prototype = Ey.prototype);
      Iy.constructor = Oy;
      var Ay = Iy.toString,
        Ry = 'Symbol(test)' == String(Ey('test')),
        jy = /^Symbol\((.*)\)[^)]+$/;
      Sy(Iy, 'description', {
        configurable: !0,
        get: function () {
          var e = Cy(this) ? this.valueOf() : this,
            t = Ay.call(e);
          if (Py(ky, e)) return '';
          var n = Ry ? t.slice(7, -1) : t.replace(jy, '$1');
          return '' === n ? void 0 : n;
        },
      }),
        gy({ global: !0, forced: !0 }, { Symbol: Oy });
    }
    var Ly = $,
      _y = Ps.forEach,
      Uy = (function (e, t) {
        var n = [][e];
        return (
          !!n &&
          Ly(function () {
            n.call(
              null,
              t ||
                function () {
                  throw 1;
                },
              1
            );
          })
        );
      })('forEach')
        ? [].forEach
        : function (e) {
            return _y(this, e, arguments.length > 1 ? arguments[1] : void 0);
          },
      Ty = p,
      My = Sf,
      Fy = kf,
      Ny = Uy,
      Vy = Me,
      Dy = function (e) {
        if (e && e.forEach !== Ny)
          try {
            Vy(e, 'forEach', Ny);
          } catch (lg) {
            e.forEach = Ny;
          }
      };
    for (var Hy in My) Dy(Ty[Hy] && Ty[Hy].prototype);
    Dy(Fy);
    var By = (function () {
        function e(t, n, r) {
          var o,
            i,
            c = this;
          if (
            (a(this, e),
            (this.auth = n == Yd.Auth),
            (this.publicId = t.publicId),
            (this.description = t.description),
            (this.amount = t.amount),
            (this.currency = null === (o = t.currency) || void 0 === o ? void 0 : o.toUpperCase()),
            t.invoiceId && (this.invoiceId = String(t.invoiceId)),
            (this.accountId = t.accountId),
            (this.localOrder = t.localOrder),
            (this.cryptogramMode = null !== (i = t.cryptogramMode) && void 0 !== i ? i : r),
            (this.email = t.email),
            (this.requireEmail = t.requireEmail),
            (this.skin = t.skin),
            (this.retryPayment = t.retryPayment),
            (this.payer = t.payer),
            (this.payerServiceFee = t.payerServiceFee),
            (this.escrow = t.escrow),
            null != t.data)
          )
            try {
              this.data = JSON.parse(JSON.stringify(t.data));
            } catch (s) {
              this.data = t.data;
            }
          Object.keys(this).forEach(
            function (e) {
              return u(this, c), null == this[e] && delete this[e];
            }.bind(this)
          ),
            this.fixEscrow(),
            e.warnExtraFields(this, t);
        }
        return (
          s(
            e,
            [
              {
                key: 'fixEscrow',
                value: function () {
                  var e = this;
                  if (null == this.escrow);
                  else {
                    if (null != this.data) {
                      var t = Object.keys(this.data).find(
                        function (t) {
                          return u(this, e), t.toLowerCase() === 'cloudpayments'.toLowerCase();
                        }.bind(this)
                      );
                      return null == t
                        ? void (this.data.cloudPayments = { escrow: this.escrow })
                        : void (this.data[t].escrow = this.escrow);
                    }
                    this.data = { cloudPayments: { escrow: this.escrow } };
                  }
                },
              },
            ],
            [
              {
                key: 'warnExtraFields',
                value: function (e, t) {
                  var n = this;
                  Object.keys(t).forEach(
                    function (t) {
                      u(this, n),
                        Object.prototype.hasOwnProperty.call(e, t) ||
                          console.warn("Unsupported 'PaymentOptions' field: '".concat(t, "'"));
                    }.bind(this)
                  );
                },
              },
            ]
          ),
          e
        );
      })(),
      $y = {
        baseUrl: 'https://widget.cloudpayments.ru',
        indexPage: '/widget',
        notSupportedUrl: '/widget/not_supported.html',
        resultPage: '/widget/result.html',
      },
      qy = (function () {
        function e() {
          a(this, e);
        }
        return (
          s(e, null, [
            {
              key: 'enableLogs',
              value: function () {
                this.enableLogging = !0;
              },
            },
            {
              key: 'LogInfo',
              value: function (e, t) {
                this.enableLogging &&
                  console.info('%c'.concat(e.toUpperCase()), 'background: #222; color: #bada55', t);
              },
            },
          ]),
          e
        );
      })();
    l(qy, 'enableLogging', !!Xd.getQueryParameterByName('debug'));
    var Gy = Zn,
      Wy = $,
      Zy = ss,
      zy = le,
      Ky = E,
      Yy = rn,
      Xy = Hs,
      Jy = ps,
      Qy = Gs,
      em = B,
      tm = re('isConcatSpreadable'),
      nm = 9007199254740991,
      rm = 'Maximum allowed index exceeded',
      om =
        em >= 51 ||
        !Wy(function () {
          var e = [];
          return (e[tm] = !1), e.concat()[0] !== e;
        }),
      im = Qy('concat'),
      am = function (e) {
        if (!zy(e)) return !1;
        var t = e[tm];
        return void 0 !== t ? !!t : Zy(e);
      };
    Gy(
      { target: 'Array', proto: !0, forced: !om || !im },
      {
        concat: function (e) {
          var t,
            n,
            r,
            o,
            i,
            a = Ky(this),
            c = Jy(a, 0),
            s = 0;
          for (t = -1, r = arguments.length; t < r; t++)
            if (am((i = -1 === t ? a : arguments[t]))) {
              if (s + (o = Yy(i.length)) > nm) throw TypeError(rm);
              for (n = 0; n < o; n++, s++) n in i && Xy(c, s, i[n]);
            } else {
              if (s >= nm) throw TypeError(rm);
              Xy(c, s++, i);
            }
          return (c.length = s), c;
        },
      }
    );
    var cm = ce,
      sm = se.f,
      lm = Function.prototype,
      um = lm.toString,
      fm = /^\s*function ([^ (]*)/,
      hm = 'name';
    cm &&
      !(hm in lm) &&
      sm(lm, hm, {
        configurable: !0,
        get: function () {
          try {
            return um.call(this).match(fm)[1];
          } catch (lg) {
            return '';
          }
        },
      });
    var pm = Zn,
      dm = sn,
      vm = en,
      ym = rn,
      mm = E,
      gm = ps,
      wm = Hs,
      bm = Gs('splice'),
      Pm = Math.max,
      Cm = Math.min,
      Sm = 9007199254740991,
      xm = 'Maximum allowed length exceeded';
    pm(
      { target: 'Array', proto: !0, forced: !bm },
      {
        splice: function (e, t) {
          var n,
            r,
            o,
            i,
            a,
            c,
            s = mm(this),
            l = ym(s.length),
            u = dm(e, l),
            f = arguments.length;
          if (
            (0 === f
              ? (n = r = 0)
              : 1 === f
              ? ((n = 0), (r = l - u))
              : ((n = f - 2), (r = Cm(Pm(vm(t), 0), l - u))),
            l + n - r > Sm)
          )
            throw TypeError(xm);
          for (o = gm(s, r), i = 0; i < r; i++) (a = u + i) in s && wm(o, i, s[a]);
          if (((o.length = r), n < r)) {
            for (i = u; i < l - r; i++) (c = i + n), (a = i + r) in s ? (s[c] = s[a]) : delete s[c];
            for (i = l; i > l - r + n; i--) delete s[i - 1];
          } else if (n > r)
            for (i = l - r; i > u; i--)
              (c = i + n - 1), (a = i + r - 1) in s ? (s[c] = s[a]) : delete s[c];
          for (i = 0; i < n; i++) s[i + u] = arguments[i + 2];
          return (s.length = l - r + n), o;
        },
      }
    );
    var Em = (function () {
      function e(t) {
        a(this, e),
          l(this, '_currentValue', void 0),
          l(this, '_subscribers', []),
          (this._currentValue = t);
      }
      return (
        s(e, [
          {
            key: 'value',
            set: function (e) {
              (this._currentValue = e), this.notifySubscribers();
            },
          },
          {
            key: 'subscribe',
            value: function (e) {
              var t = this;
              this._subscribers.push(e);
              var n = function () {
                u(this, t);
                var n = this._subscribers.indexOf(e);
                this._subscribers.splice(n, 1);
              }.bind(this);
              return n;
            },
          },
          {
            key: 'next',
            value: function (e) {
              this.value = e;
            },
          },
          {
            key: 'notifySubscribers',
            value: function () {
              var e = this;
              this._subscribers.forEach(
                function (t) {
                  u(this, e), t(this._currentValue);
                }.bind(this)
              );
            },
          },
        ]),
        e
      );
    })();
    var km = !1;
    if ('undefined' != typeof window) {
      var Om = {
        get passive() {
          km = !0;
        },
      };
      window.addEventListener('testPassive', null, Om),
        window.removeEventListener('testPassive', null, Om);
    }
    var Im,
      Am,
      Rm =
        'undefined' != typeof window &&
        window.navigator &&
        window.navigator.platform &&
        (/iP(ad|hone|od)/.test(window.navigator.platform) ||
          ('MacIntel' === window.navigator.platform && window.navigator.maxTouchPoints > 1)),
      jm = [],
      Lm = !1,
      _m = -1,
      Um = void 0,
      Tm = void 0,
      Mm = function (e) {
        return jm.some(function (t) {
          return !(!t.options.allowTouchMove || !t.options.allowTouchMove(e));
        });
      },
      Fm = function (e) {
        var t = e || window.event;
        return (
          !!Mm(t.target) || t.touches.length > 1 || (t.preventDefault && t.preventDefault(), !1)
        );
      },
      Nm = function (e, t) {
        if (e) {
          if (
            !jm.some(function (t) {
              return t.targetElement === e;
            })
          ) {
            var n = { targetElement: e, options: t || {} };
            (jm = [].concat(
              (function (e) {
                if (Array.isArray(e)) {
                  for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
                  return n;
                }
                return Array.from(e);
              })(jm),
              [n]
            )),
              Rm
                ? ((e.ontouchstart = function (e) {
                    1 === e.targetTouches.length && (_m = e.targetTouches[0].clientY);
                  }),
                  (e.ontouchmove = function (t) {
                    1 === t.targetTouches.length &&
                      (function (e, t) {
                        var n = e.targetTouches[0].clientY - _m;
                        !Mm(e.target) &&
                          ((t && 0 === t.scrollTop && n > 0) ||
                          ((function (e) {
                            return !!e && e.scrollHeight - e.scrollTop <= e.clientHeight;
                          })(t) &&
                            n < 0)
                            ? Fm(e)
                            : e.stopPropagation());
                      })(t, e);
                  }),
                  Lm ||
                    (document.addEventListener('touchmove', Fm, km ? { passive: !1 } : void 0),
                    (Lm = !0)))
                : (function (e) {
                    if (void 0 === Tm) {
                      var t = !!e && !0 === e.reserveScrollBarGap,
                        n = window.innerWidth - document.documentElement.clientWidth;
                      t &&
                        n > 0 &&
                        ((Tm = document.body.style.paddingRight),
                        (document.body.style.paddingRight = n + 'px'));
                    }
                    void 0 === Um &&
                      ((Um = document.body.style.overflow),
                      (document.body.style.overflow = 'hidden'));
                  })(t);
          }
        } else
          console.error(
            'disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.'
          );
      },
      Vm = function (e) {
        e
          ? ((jm = jm.filter(function (t) {
              return t.targetElement !== e;
            })),
            Rm
              ? ((e.ontouchstart = null),
                (e.ontouchmove = null),
                Lm &&
                  0 === jm.length &&
                  (document.removeEventListener('touchmove', Fm, km ? { passive: !1 } : void 0),
                  (Lm = !1)))
              : jm.length ||
                (void 0 !== Tm && ((document.body.style.paddingRight = Tm), (Tm = void 0)),
                void 0 !== Um && ((document.body.style.overflow = Um), (Um = void 0))))
          : console.error(
              'enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.'
            );
      },
      Dm = (function () {
        function e() {
          a(this, e);
        }
        return (
          s(e, null, [
            {
              key: 'isApplePayAvailable',
              value: function () {
                if ('ApplePaySession' in window)
                  try {
                    return ApplePaySession.canMakePayments()
                      ? Promise.resolve()
                      : Promise.reject('ApplePaySession CanMakePayments false');
                  } catch (e) {
                    return Promise.reject(e);
                  }
                return Promise.reject('ApplePaySession not in Window');
              },
            },
            {
              key: 'createApplePaymentRequest',
              value: function (e, t, n, r, o) {
                var i = ['visa', 'masterCard'];
                qy.LogInfo('createApplePaymentRequest', {
                  terminalUrl: e,
                  amount: t,
                  currency: n,
                  requireEmail: r,
                  label: o,
                }),
                  ApplePaySession.supportsVersion(11) && i.push('mir');
                var a = {
                  countryCode: 'RU',
                  currencyCode: n,
                  supportedNetworks: i,
                  merchantCapabilities: ['supports3DS'],
                  total: { label: null != o ? o : 'Pay to ' + e, amount: t.toString() },
                };
                return r && (a.requiredShippingContactFields = ['email']), a;
              },
            },
            {
              key: 'getApplePaySession',
              value: function (t, n, r, o, i) {
                var a = e.createApplePaymentRequest(t, n, r, o, i);
                return new ApplePaySession(1, a);
              },
            },
          ]),
          e
        );
      })();
    let Hm, Bm, $m, qm, Gm;
    !(function (e) {
      (e.Payment = 'payment'),
        (e.Installment = 'installment'),
        (e.Error = 'error'),
        (e.Cancel = 'cancel');
    })(Im || (Im = {})),
      (function (e) {
        (e.Success = 'success'),
          (e.Appointment = 'appointment'),
          (e.Fail = 'fail'),
          (e.Reject = 'reject'),
          (e.Cancel = 'cancel');
      })(Am || (Am = {})),
      (function (e) {
        (e.Call = 'call'),
          (e.Reply = 'reply'),
          (e.Syn = 'syn'),
          (e.SynAck = 'synAck'),
          (e.Ack = 'ack');
      })(Hm || (Hm = {})),
      (function (e) {
        (e.Fulfilled = 'fulfilled'), (e.Rejected = 'rejected');
      })(Bm || (Bm = {})),
      (function (e) {
        (e.ConnectionDestroyed = 'ConnectionDestroyed'),
          (e.ConnectionTimeout = 'ConnectionTimeout'),
          (e.NoIframeSrc = 'NoIframeSrc');
      })($m || ($m = {})),
      (function (e) {
        e.DataCloneError = 'DataCloneError';
      })(qm || (qm = {})),
      (function (e) {
        e.Message = 'message';
      })(Gm || (Gm = {}));
    const Wm = { 'http:': '80', 'https:': '443' },
      Zm = /^(https?:)?\/\/([^/:]+)?(:(\d+))?/,
      zm = ['file:', 'data:'];
    const Km = function ({ name: e, message: t, stack: n }) {
      return { name: e, message: t, stack: n };
    };
    let Ym = 0;
    var Xm = function () {
      return ++Ym;
    };
    const Jm = function (e) {
        return e ? e.split('.') : [];
      },
      Qm = function (e, t, n) {
        const r = Jm(t);
        return (
          r.reduce(function (e, t, o) {
            return void 0 === e[t] && (e[t] = {}), o === r.length - 1 && (e[t] = n), e[t];
          }, e),
          e
        );
      },
      eg = function (e, t) {
        const n = {};
        return (
          Object.keys(e).forEach(function (r) {
            const o = e[r],
              i = (function (e, t) {
                const n = Jm(t || '');
                return (
                  n.push(e),
                  (function (e) {
                    return e.join('.');
                  })(n)
                );
              })(r, t);
            'object' == typeof o && Object.assign(n, eg(o, i)),
              'function' == typeof o && (n[i] = o);
          }),
          n
        );
      };
    var tg = function (e, t, n, r, o) {
        const { localName: i, local: a, remote: c, originForSending: s, originForReceiving: l } = t;
        let u = !1;
        o(`${i}: Connecting call sender`);
        const f = function (e) {
            return function (...t) {
              let n;
              o(`${i}: Sending ${e}() call`);
              try {
                c.closed && (n = !0);
              } catch (f) {
                n = !0;
              }
              if ((n && r(), u)) {
                const t = new Error(`Unable to send ${e}() call due to destroyed connection`);
                throw ((t.code = $m.ConnectionDestroyed), t);
              }
              return new Promise(function (n, r) {
                const u = Xm(),
                  f = function (t) {
                    if (t.source !== c || t.data.penpal !== Hm.Reply || t.data.id !== u) return;
                    if ('*' !== l && t.origin !== l)
                      return void o(
                        `${i} received message from origin ${t.origin} which did not match expected origin ${l}`
                      );
                    const s = t.data;
                    o(`${i}: Received ${e}() reply`), a.removeEventListener(Gm.Message, f);
                    let h = s.returnValue;
                    s.returnValueIsError &&
                      (h = (function (e) {
                        const t = new Error();
                        return (
                          Object.keys(e).forEach(function (n) {
                            return (t[n] = e[n]);
                          }),
                          t
                        );
                      })(h)),
                      (s.resolution === Bm.Fulfilled ? n : r)(h);
                  };
                a.addEventListener(Gm.Message, f);
                const h = { penpal: Hm.Call, id: u, methodName: e, args: t };
                c.postMessage(h, s);
              });
            };
          },
          h = n.reduce(function (e, t) {
            return (e[t] = f(t)), e;
          }, {});
        return (
          Object.assign(
            e,
            (function (e) {
              const t = {};
              for (const n in e) Qm(t, n, e[n]);
              return t;
            })(h)
          ),
          function () {
            u = !0;
          }
        );
      },
      ng = function (e, t, n, r, o) {
        const { destroy: i, onDestroy: a } = r;
        let c, s;
        const l = {};
        return function (r) {
          if ('*' !== t && r.origin !== t)
            return void o(
              `Parent: Handshake - Received ACK message from origin ${r.origin} which did not match expected origin ${t}`
            );
          o('Parent: Handshake - Received ACK');
          const u = {
            localName: 'Parent',
            local: window,
            remote: r.source,
            originForSending: n,
            originForReceiving: t,
          };
          c && c(),
            (c = (function (e, t, n) {
              const {
                localName: r,
                local: o,
                remote: i,
                originForSending: a,
                originForReceiving: c,
              } = e;
              let s = !1;
              const l = function (e) {
                if (e.source !== i || e.data.penpal !== Hm.Call) return;
                if ('*' !== c && e.origin !== c)
                  return void n(
                    `${r} received message from origin ${e.origin} which did not match expected origin ${c}`
                  );
                const o = e.data,
                  { methodName: l, args: u, id: f } = o;
                n(`${r}: Received ${l}() call`);
                const h = function (e) {
                  return function (t) {
                    if ((n(`${r}: Sending ${l}() reply`), s))
                      return void n(
                        `${r}: Unable to send ${l}() reply due to destroyed connection`
                      );
                    const o = { penpal: Hm.Reply, id: f, resolution: e, returnValue: t };
                    e === Bm.Rejected &&
                      t instanceof Error &&
                      ((o.returnValue = Km(t)), (o.returnValueIsError = !0));
                    try {
                      i.postMessage(o, a);
                    } catch (c) {
                      if (c.name === qm.DataCloneError) {
                        const e = {
                          penpal: Hm.Reply,
                          id: f,
                          resolution: Bm.Rejected,
                          returnValue: Km(c),
                          returnValueIsError: !0,
                        };
                        i.postMessage(e, a);
                      }
                      throw c;
                    }
                  };
                };
                new Promise(function (e) {
                  return e(t[l].apply(t, u));
                }).then(h(Bm.Fulfilled), h(Bm.Rejected));
              };
              return (
                o.addEventListener(Gm.Message, l),
                function () {
                  (s = !0), o.removeEventListener(Gm.Message, l);
                }
              );
            })(u, e, o)),
            a(c),
            s &&
              s.forEach(function (e) {
                delete l[e];
              }),
            (s = r.data.methodNames);
          const f = tg(l, u, s, i, o);
          return a(f), l;
        };
      };
    var rg = function (e) {
        let { iframe: t, methods: n = {}, childOrigin: r, timeout: o, debug: i = !1 } = e;
        const a = (function (e) {
            return function (...t) {
              e && console.log('[Penpal]', ...t);
            };
          })(i),
          c = (function (e, t) {
            const n = [];
            let r = !1;
            return {
              destroy(o) {
                r ||
                  ((r = !0),
                  t(`${e}: Destroying connection`),
                  n.forEach(function (e) {
                    e(o);
                  }));
              },
              onDestroy(e) {
                r ? e() : n.push(e);
              },
            };
          })('Parent', a),
          { onDestroy: s, destroy: l } = c;
        r ||
          (!(function (e) {
            if (!e.src && !e.srcdoc) {
              const e = new Error('Iframe must have src or srcdoc property defined.');
              throw ((e.code = $m.NoIframeSrc), e);
            }
          })(t),
          (r = (function (e) {
            if (
              e &&
              zm.find(function (t) {
                return e.startsWith(t);
              })
            )
              return 'null';
            const t = document.location,
              n = Zm.exec(e);
            let r, o, i;
            return (
              n
                ? ((r = n[1] ? n[1] : t.protocol), (o = n[2]), (i = n[4]))
                : ((r = t.protocol), (o = t.hostname), (i = t.port)),
              `${r}//${o}${i && i !== Wm[r] ? `:${i}` : ''}`
            );
          })(t.src)));
        const u = 'null' === r ? '*' : r,
          f = eg(n),
          h = (function (e, t, n, r) {
            return function (o) {
              if ('*' !== n && o.origin !== n)
                return void e(
                  `Parent: Handshake - Received SYN message from origin ${o.origin} which did not match expected origin ${n}`
                );
              e('Parent: Handshake - Received SYN, responding with SYN-ACK');
              const i = { penpal: Hm.SynAck, methodNames: Object.keys(t) };
              o.source.postMessage(i, r);
            };
          })(a, f, r, u),
          p = ng(f, r, u, c, a),
          d = new Promise(function (e, n) {
            const r = (function (e, t) {
                let n;
                return (
                  void 0 !== e &&
                    (n = window.setTimeout(function () {
                      const n = new Error(`Connection timed out after ${e}ms`);
                      (n.code = $m.ConnectionTimeout), t(n);
                    }, e)),
                  function () {
                    clearTimeout(n);
                  }
                );
              })(o, l),
              i = function (n) {
                if (n.source === t.contentWindow && n.data)
                  if (n.data.penpal !== Hm.Syn)
                    if (n.data.penpal !== Hm.Ack);
                    else {
                      const t = p(n);
                      t && (r(), e(t));
                    }
                  else h(n);
              };
            window.addEventListener(Gm.Message, i),
              a('Parent: Awaiting handshake'),
              (function (e, t) {
                const { destroy: n, onDestroy: r } = t,
                  o = setInterval(function () {
                    e.isConnected || (clearInterval(o), n());
                  }, 6e4);
                r(function () {
                  clearInterval(o);
                });
              })(t, c),
              s(function (e) {
                window.removeEventListener(Gm.Message, i), e && n(e);
              });
          });
        return {
          promise: d,
          destroy() {
            l();
          },
        };
      },
      og = (function () {
        function e(t, r, o, c) {
          var s = this;
          if (
            (a(this, e),
            l(this, 'alternateEmbed', !1),
            l(this, 'savedScrollPosition', null),
            l(this, 'connectionResolvers', []),
            l(this, 'connection', null),
            l(this, 'appledStyle', null),
            l(this, 'applePayPaymentResult', new Em()),
            l(this, 'unsupportedBrowser', Xd.isIE()),
            l(
              this,
              'getConnection',
              function () {
                var e = this;
                return (
                  u(this, s),
                  new Promise(
                    function (t, n) {
                      var r = this;
                      if ((u(this, e), this.unsupportedBrowser)) {
                        var o = function (e) {
                          if ((u(this, r), e.origin == $y.baseUrl)) {
                            try {
                              'close' == JSON.parse(e.data).action && this.hideWindow();
                            } catch (t) {
                              return;
                            }
                            window.removeEventListener('message', o);
                          }
                        }.bind(this);
                        return (
                          window.addEventListener('message', o, !1), this.showWindow(), void n('IE')
                        );
                      }
                      null != this.connection
                        ? t(this.connection)
                        : this.connectionResolvers.push(t);
                    }.bind(this)
                  )
                );
              }.bind(this)
            ),
            l(
              this,
              'showWindow',
              function () {
                var e, t;
                u(this, s),
                  this.container &&
                    (this.addViewPortMeta(),
                    Xd.addClass(this.iframe, 'with-appled'),
                    (e = document),
                    (t = e.getElementById('cloudpayments-loading-overlay-63456123')) &&
                      t.parentNode &&
                      t.parentNode.removeChild(t),
                    Xd.showHtmlElement(this.container),
                    Nm(this.container),
                    this.alternateEmbed &&
                      !this.appledStyle &&
                      ((this.savedScrollPosition = document.body.scrollTop),
                      (this.appledStyle = document.createElement('style')),
                      (this.appledStyle.type = 'text/css'),
                      (this.appledStyle.innerHTML =
                        '\n                html {height: 100% !important; position: static !important}\n                body {margin: 0 !important; padding: 0 !important; position: static !important; height: 100vh !important}\n                body * {display: none !important}\n                #'
                          .concat(
                            this.container.id,
                            ' {position: static !important}\n                #'
                          )
                          .concat(
                            this.container.id,
                            ', #cloudpayments-backdrop-8978968765, iframe.with-appled {display: block !important}\n                .payment-tools-container.with-appled {display: table !important}\n                .payment-tools-container.with-appled div {display: table-cell !important}\n                .payment-tools-container.with-appled div *:not(style) {display: block !important}\n            '
                          )),
                      document.body.appendChild(this.appledStyle),
                      setTimeout(function () {
                        window.scrollTo(0, 0);
                      }, 200)));
              }.bind(this)
            ),
            l(
              this,
              'hideWindow',
              function () {
                if (
                  (u(this, s),
                  Vm(this.container),
                  this.savedScrollPosition &&
                    (window.scrollTo(0, this.savedScrollPosition),
                    (this.savedScrollPosition = null)),
                  this.appledStyle)
                ) {
                  try {
                    this.appledStyle.remove();
                  } catch (e) {}
                  this.appledStyle = null;
                }
                this.removeViewPortMeta(),
                  this.iframe && Xd.removeClass(this.iframe, 'with-appled'),
                  Xd.hideHtmlElement(this.container);
                try {
                  this.container.remove();
                } catch (e) {}
                this.onFrameDestroyed &&
                  this.onFrameDestroyed(this.apiCallCompletedData, this.cryptogramModeData);
              }.bind(this)
            ),
            l(
              this,
              'setApplePayPaymentResult',
              function (e) {
                u(this, s), this.applePayPaymentResult.next(e);
              }.bind(this)
            ),
            l(
              this,
              'processApplePaySessionAndPay',
              (function () {
                var e = i(
                  regeneratorRuntime.mark(function e(t, n, r) {
                    var o,
                      i,
                      a,
                      c = this;
                    return regeneratorRuntime.wrap(
                      function (e) {
                        for (;;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (
                                qy.LogInfo('processApplePaySessionAndPay'),
                                (e.next = 3),
                                s.getConnection()
                              );
                            case 3:
                              return (
                                (i = e.sent),
                                qy.LogInfo('frameConnection', i),
                                (e.next = 7),
                                Dm.isApplePayAvailable()
                              );
                            case 7:
                              return (
                                (a = Dm.getApplePaySession(
                                  t,
                                  n.amount,
                                  n.currency,
                                  null !== (o = n.requireEmail) && void 0 !== o && o,
                                  r
                                )),
                                qy.LogInfo('applePaySession created', a),
                                e.abrupt(
                                  'return',
                                  new Promise(
                                    function (e, t) {
                                      var r = this;
                                      u(this, c),
                                        (a.oncancel = function (e) {
                                          u(this, r),
                                            qy.LogInfo('applePaySession canceled', e),
                                            t(e);
                                        }.bind(this)),
                                        (a.onvalidatemerchant = function (e) {
                                          var t = this;
                                          u(this, r),
                                            qy.LogInfo('applePaySession onvalidatemerchant', e);
                                          var o = {
                                            ValidationUrl: e.validationURL,
                                            TerminalPublicId: n.publicId,
                                            SharedAppleMerchantIdUrl: Xd.getHostnameFromUrl(
                                              window.location.href
                                            ),
                                          };
                                          qy.LogInfo(
                                            'applePaySession startApplePaySession request',
                                            o
                                          ),
                                            i.startApplePaySession(o).then(
                                              function (e) {
                                                u(this, t),
                                                  qy.LogInfo(
                                                    'applePaySession startApplePaySession api response',
                                                    e
                                                  ),
                                                  a.completeMerchantValidation(e.Model);
                                              }.bind(this)
                                            );
                                        }.bind(this)),
                                        (a.onpaymentauthorized = function (t) {
                                          var n = this;
                                          u(this, r),
                                            qy.LogInfo('applePaySession onpaymentauthorized', t),
                                            i.payByApplePay(t.payment).then(
                                              function (t) {
                                                u(this, n),
                                                  a.completePayment(
                                                    t.Success
                                                      ? ApplePaySession.STATUS_SUCCESS
                                                      : ApplePaySession.STATUS_FAILURE
                                                  ),
                                                  e(t);
                                              }.bind(this)
                                            );
                                        }.bind(this)),
                                        a.begin();
                                    }.bind(this)
                                  )
                                )
                              );
                            case 10:
                            case 'end':
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                );
                return function (t, n, r) {
                  return e.apply(this, arguments);
                };
              })()
            ),
            l(
              this,
              'addViewPortMeta',
              function () {
                u(this, s);
                var e = document.getElementsByTagName('head')[0],
                  t = document.createElement('meta');
                (t.id = 'cloudpayments-widget-viewport'),
                  (t.name = 'viewport'),
                  (t.content =
                    'width=device-width, height=device-height, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'),
                  e.appendChild(t);
              }.bind(this)
            ),
            this.unsupportedBrowser)
          ) {
            this.iframe = document.createElement('iframe');
            var f = new URL($y.baseUrl + $y.notSupportedUrl);
            return (
              (this.iframe.src = f.toString()),
              (this.iframe.style.cssText =
                'height: 100% !important;width: 100% !important;position: fixed !important;z-index: 9999 !important;border: 0 !important; top: 0 !important;bottom: 0 !important;left: 0 !important;right: 0px !important;max-height: 100% !important;'),
              (this.container = e.createContainer(this.alternateEmbed)),
              this.container.appendChild(this.iframe),
              e.ensureContainer(r).appendChild(this.container),
              void this.hideWindow()
            );
          }
          (this.alternateEmbed = t), (this.iframe = document.createElement('iframe'));
          var h = new URL(''.concat($y.baseUrl).concat($y.indexPage, '/'));
          o && h.searchParams.append('locale', o),
            c && h.searchParams.append('debug', 'true'),
            (this.iframe.src = h.toString()),
            (this.iframe.allowPaymentRequest = !0),
            (this.iframe.style.cssText =
              'height: 100% !important;width: 100% !important;position: fixed !important;z-index: 9999 !important;border: 0 !important; top: 0 !important;bottom: 0 !important;left: 0 !important;right: 0px !important;max-height: 100% !important;'),
            (this.container = e.createContainer(this.alternateEmbed)),
            this.container.appendChild(this.iframe),
            this.hideWindow(),
            e.ensureContainer(r).appendChild(this.container);
          var p = {
            showWindow: this.showWindow,
            hideWindow: this.hideWindow,
            setApplePaymentResult: this.setApplePayPaymentResult,
            processApplePayment: this.processApplePaySessionAndPay,
            completeWidgetCallback: function (e, t) {
              var r;
              if ((u(this, s), this.onPaymentCompleted)) {
                var o,
                  i = n({}, e);
                if (null != e && null !== (o = e.data) && void 0 !== o && o.Model) {
                  var a,
                    c,
                    l,
                    f,
                    h =
                      null == i ||
                      null === (a = i.data) ||
                      void 0 === a ||
                      null === (c = a.Model) ||
                      void 0 === c
                        ? void 0
                        : c.TransactionId,
                    p =
                      null == i ||
                      null === (l = i.data) ||
                      void 0 === l ||
                      null === (f = l.Model) ||
                      void 0 === f
                        ? void 0
                        : f.ReasonCode;
                  (i.data = { email: t }),
                    h && (i.data.transactionId = h),
                    p && (i.data.ReasonCode = p);
                }
                e.type === Im.Installment && delete i.data, this.onPaymentCompleted(i);
              }
              if (null != e && null !== (r = e.data) && void 0 !== r && r.Model) {
                var d,
                  v,
                  y,
                  m = {
                    success: (null == e ? void 0 : e.status) === Am.Success,
                    message:
                      null == e || null === (d = e.data) || void 0 === d ? void 0 : d.Message,
                    code:
                      null == e ||
                      null === (v = e.data) ||
                      void 0 === v ||
                      null === (y = v.Model) ||
                      void 0 === y
                        ? void 0
                        : y.ReasonCode,
                    email: t,
                  };
                (this.apiCallCompletedData = m), this.onComplete && this.onComplete(m);
              }
            }.bind(this),
            isApplePayAvailiable: function () {
              return u(this, s), 'ApplePaySession' in window && ApplePaySession.canMakePayments();
            }.bind(this),
            emitCryptogramAndClose: function (e, t) {
              u(this, s),
                (this.cryptogramModeData = { cryptogram: e, email: t }),
                this.hideWindow();
            }.bind(this),
          };
          (this.connectionHandler = rg({ iframe: this.iframe, methods: p })),
            this.connectionHandler.promise.then(
              function (e) {
                var t = this;
                u(this, s),
                  (this.connection = e),
                  this.connectionResolvers.forEach(
                    function (n) {
                      return u(this, t), n(e);
                    }.bind(this)
                  );
              }.bind(this)
            );
        }
        return (
          s(
            e,
            [
              {
                key: 'removeViewPortMeta',
                value: function () {
                  var e = document.getElementById('cloudpayments-widget-viewport');
                  e && document.getElementsByTagName('head')[0].removeChild(e);
                },
              },
            ],
            [
              {
                key: 'createContainer',
                value: function () {
                  var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                    t = document.createElement('div');
                  return (
                    (t.id = 'cp-scrollable-' + Math.floor(1e8 * Math.random()).toString()),
                    e ||
                      (t.style.cssText =
                        'z-index:9997;text-align:left;height:100%;width:100%;position:fixed;left:0;top:0;transition:opacity 0.15s;overflow:auto;-webkit-overflow-scrolling:touch;pointer-events:all;'),
                    (t.style.pointerEvents = 'all'),
                    t
                  );
                },
              },
              {
                key: 'ensureContainer',
                value: function (e) {
                  if (null == e) return document.body;
                  if ('string' == typeof e) {
                    var t = document.getElementById(e);
                    return null == t
                      ? (console.warn(
                          'Specified container with id '.concat(
                            e,
                            ' not found. document.body will used instead'
                          )
                        ),
                        document.body)
                      : t;
                  }
                  if ('object' === r(e) && 1 === e.nodeType) return e;
                  throw new Error(
                    "Argument 'container' must be an ID of element or the element itself"
                  );
                },
              },
            ]
          ),
          e
        );
      })(),
      ig = (function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          a(this, e),
            l(this, 'alternateEmbed', !1),
            l(this, 'deviceDetector', new Fs()),
            l(this, 'legacyCallbackObject', { shouldInvokeOnCompleteInstantly: !1 }),
            l(this, 'callbackObject', {}),
            l(this, 'lastCallbackResult', { type: Im.Cancel }),
            l(this, 'frameDestroyed', !1),
            l(this, 'onCloseWidgetResolver', null),
            (this.options = this.setCloudPaymentsOptionsDefaults(t)),
            t.debug && qy.enableLogs(),
            (this.alternateEmbed = this.deviceDetector.isIOs || this.deviceDetector.isAndroid),
            (this.containerManager = this.createFrameConnector());
        }
        return (
          s(e, [
            {
              key: 'charge',
              value: function (e, t, n, r) {
                (e.auth = !1),
                  (this.legacyCallbackObject.onSuccess = t),
                  (this.legacyCallbackObject.onFail = n),
                  (this.legacyCallbackObject.onComplete = r),
                  this.startPayment(Yd.Charge, e, !1);
              },
            },
            {
              key: 'auth',
              value: function (e, t, n, r) {
                var o = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4];
                if (o && 'boolean' != typeof o)
                  throw new Error("Argument 'auth' must be a boolean");
                (e.auth = !0),
                  (this.legacyCallbackObject.onSuccess = t),
                  (this.legacyCallbackObject.onFail = n),
                  (this.legacyCallbackObject.onComplete = r),
                  this.startPayment(Yd.Auth, e, !1);
              },
            },
            {
              key: 'pay',
              value: function (e, t, n) {
                var r = this;
                return (
                  (this.legacyCallbackObject.onSuccess = null == n ? void 0 : n.onSuccess),
                  (this.legacyCallbackObject.onFail = null == n ? void 0 : n.onFail),
                  (this.legacyCallbackObject.onComplete = null == n ? void 0 : n.onComplete),
                  new Promise(
                    function (n) {
                      u(this, r), (this.onCloseWidgetResolver = n), this.startPayment(e, t, !0);
                    }.bind(this)
                  )
                );
              },
            },
            {
              key: 'startPayment',
              value: function (e, t) {
                var n = this,
                  r = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                if (this.paymentOptions)
                  throw new Error(
                    'Payment options already set. Prevented multiply widget windows.'
                  );
                if (e !== Yd.Auth && e !== Yd.Charge)
                  throw new Error("Option 'type' must be 'auth' or 'charge'");
                try {
                  this.validateOptions(t);
                } catch (lg) {
                  if (this.onCloseWidgetResolver)
                    return (
                      (this.lastCallbackResult = { type: Im.Error, data: lg }),
                      void this.invokeCallbacks()
                    );
                }
                var o = new By(t, e, this.options.cryptogramMode);
                Jd(document),
                  (this.paymentOptions = o),
                  (this.merchantPaymentOptions = t),
                  (this.legacyCallbackObject.shouldInvokeOnCompleteInstantly = r),
                  this.frameDestroyed &&
                    (qy.LogInfo('Payment frame destroyed. Recreating.'),
                    (this.containerManager = this.createFrameConnector())),
                  this.containerManager
                    .getConnection()
                    .then(
                      function (e) {
                        u(this, n),
                          e.setOptions(
                            this.paymentOptions,
                            { origin: window.location.origin },
                            this.options
                          );
                      }.bind(this)
                    )
                    .catch(
                      function () {
                        u(this, n), console.warn('IE Detected. Payment prevented.');
                      }.bind(this)
                    ),
                  history.pushState(
                    { paymentOptions: t, options: this.options },
                    'CloudPayments',
                    window.location.href
                  );
              },
            },
            {
              key: 'setCloudPaymentsOptionsDefaults',
              value: function (e) {
                var t = n({}, e);
                return (
                  Xd.isNullOrUndefined(t.showLoadingImage) && (t.showLoadingImage = !0),
                  Xd.isNullOrUndefined(t.applePaySupport) && (t.applePaySupport = !0),
                  Xd.isNullOrUndefined(t.googlePaySupport) && (t.googlePaySupport = !0),
                  Xd.isNullOrUndefined(t.tinkoffInstallmentSupport) &&
                    (t.tinkoffInstallmentSupport = !0),
                  Xd.isNullOrUndefined(t.yandexPaySupport) && (t.yandexPaySupport = !0),
                  Xd.isNullOrUndefined(t.masterPassSupport) && (t.masterPassSupport = !0),
                  Xd.isNullOrUndefined(t.cryptogramMode) && (t.cryptogramMode = !1),
                  t
                );
              },
            },
            {
              key: 'createFrameConnector',
              value: function () {
                var e = this,
                  t = new og(
                    this.alternateEmbed,
                    this.options.container,
                    this.options.language,
                    this.options.debug
                  );
                return (
                  (t.onFrameDestroyed = function (t, n) {
                    u(this, e), qy.LogInfo('Frame destroyed');
                    try {
                      this.invokeCallbacks(t, n);
                    } catch (r) {
                      qy.LogInfo('Error', r);
                    }
                    (this.paymentOptions = void 0),
                      (this.merchantPaymentOptions = void 0),
                      (this.frameDestroyed = !0);
                  }.bind(this)),
                  (t.onComplete = function (t) {
                    u(this, e),
                      this.legacyCallbackObject.onComplete &&
                        this.legacyCallbackObject.shouldInvokeOnCompleteInstantly &&
                        this.legacyCallbackObject.onComplete(t, this.merchantPaymentOptions);
                  }.bind(this)),
                  (t.onPaymentCompleted = function (t) {
                    u(this, e),
                      (this.lastCallbackResult = t),
                      this.oncomplete && this.oncomplete(t);
                  }.bind(this)),
                  (this.frameDestroyed = !1),
                  t
                );
              },
            },
            {
              key: 'invokeCallbacks',
              value: function (e, t) {
                var r, o, i;
                e
                  ? (e.success &&
                      this.legacyCallbackObject.onSuccess &&
                      ('function' == typeof this.legacyCallbackObject.onSuccess
                        ? this.legacyCallbackObject.onSuccess(this.merchantPaymentOptions)
                        : window.location.replace(this.legacyCallbackObject.onSuccess)),
                    !e.success &&
                      this.legacyCallbackObject.onFail &&
                      ('function' == typeof this.legacyCallbackObject.onFail
                        ? this.legacyCallbackObject.onFail(
                            e.message,
                            this.merchantPaymentOptions,
                            null === (r = e.code) || void 0 === r ? void 0 : r.toString()
                          )
                        : window.location.replace(this.legacyCallbackObject.onFail)))
                  : t ||
                    (this.legacyCallbackObject.onFail &&
                      ('function' == typeof this.legacyCallbackObject.onFail
                        ? this.legacyCallbackObject.onFail(
                            'User has cancelled',
                            this.merchantPaymentOptions,
                            void 0
                          )
                        : window.location.replace(this.legacyCallbackObject.onFail)));
                !this.legacyCallbackObject.shouldInvokeOnCompleteInstantly &&
                  this.legacyCallbackObject.onComplete &&
                  this.legacyCallbackObject.onComplete(
                    {
                      success: null !== (o = null == e ? void 0 : e.success) && void 0 !== o && o,
                      message: null == e ? void 0 : e.message,
                      code: null == e ? void 0 : e.code,
                    },
                    this.merchantPaymentOptions
                  );
                (t &&
                  this.legacyCallbackObject.onSuccess &&
                  'function' == typeof this.legacyCallbackObject.onSuccess &&
                  this.legacyCallbackObject.onSuccess(
                    this.merchantPaymentOptions,
                    null == t ? void 0 : t.cryptogram,
                    null == t ? void 0 : t.email
                  ),
                this.onCloseWidgetResolver && this.lastCallbackResult)
                  ? null !== (i = this.lastCallbackResult) &&
                    void 0 !== i &&
                    i.status &&
                    [Am.Success, Am.Appointment].includes(this.lastCallbackResult.status) &&
                    [Im.Payment, Im.Installment].includes(this.lastCallbackResult.type)
                    ? this.onCloseWidgetResolver(this.lastCallbackResult)
                    : this.onCloseWidgetResolver({ type: Im.Cancel })
                  : this.onclose &&
                    this.lastCallbackResult &&
                    this.onclose(n(n({}, this.lastCallbackResult), {}, { type: Im.Cancel }));
              },
            },
            {
              key: 'validateOptions',
              value: function (e, t) {
                if (!e.publicId) throw new Error("Option 'publicId' must be specified");
                if (!e.amount) throw new Error("Option 'amount' must be specified");
                if ('number' != typeof e.amount)
                  throw new Error("Option 'amount' must be a number");
                if (!e.currency) throw new Error("Option 'currency' must be specified");
                if (e.email && 'string' != typeof e.email)
                  throw new Error("Option 'email' must be a string");
                if (t && 'function' != typeof t)
                  throw new Error("Argument 'onCompleted' must be a function");
                if (e.requireEmail && 'boolean' != typeof e.requireEmail)
                  throw new Error("Argument 'requireEmail' must be a boolean");
                if ((!e.email && this.options.email && (e.email = this.options.email), e.escrow)) {
                  if ('RUB' != e.currency)
                    throw new Error(
                      "Option 'escrow' is not allowed with currency other than 'RUB'"
                    );
                  if (null == e.escrow.accumulationId && null == e.escrow.startAccumulation)
                    throw new Error(
                      "Option 'escrow.accumulationId' or 'escrow.startAccumulation' are required with escrow"
                    );
                  if (e.escrow.accumulationId && 1 == e.escrow.startAccumulation)
                    throw new Error(
                      "Only 'escrow.accumulationId' or 'escrow.startAccumulation' allowed at same time"
                    );
                  if (null != e.escrow.accumulationId && 'string' != typeof e.escrow.accumulationId)
                    throw new Error("Option 'escrow.accumulationId' must be a string");
                  if (
                    null != e.escrow.startAccumulation &&
                    'boolean' != typeof e.escrow.startAccumulation
                  )
                    throw new Error("Option 'escrow.accumulationId' must be a boolean");
                }
              },
            },
            {
              key: 'fixEscrow',
              value: function (e) {
                var t = this;
                if (null != e.escrow) {
                  if (null != e.data) {
                    var n = Object.keys(e.data).find(
                      function (e) {
                        return u(this, t), e.toLowerCase() === 'cloudpayments'.toLowerCase();
                      }.bind(this)
                    );
                    return null == n
                      ? ((e.data.cloudPayments = { escrow: e.escrow }), e)
                      : ((e.data[n].escrow = e.escrow), e);
                  }
                  return (e.data = { cloudPayments: { escrow: e.escrow } }), e;
                }
                return e;
              },
            },
            {
              key: 'onclose',
              get: function () {
                return this.callbackObject.onClose;
              },
              set: function (e) {
                if (e && 'function' != typeof e) throw new Error('Function required');
                this.callbackObject.onClose = e;
              },
            },
            {
              key: 'oncomplete',
              get: function () {
                return this.callbackObject.onPaymentCompleted;
              },
              set: function (e) {
                if (e && 'function' != typeof e) throw new Error('Function required');
                this.callbackObject.onPaymentCompleted = e;
              },
            },
            {
              key: 'oncryptogram',
              get: function () {
                return this.callbackObject.onCryptogramCreated;
              },
              set: function (e) {
                if (e && 'function' != typeof e) throw new Error('Function required');
                this.callbackObject.onCryptogramCreated = e;
              },
            },
          ]),
          e
        );
      })(),
      ag = ig,
      cg = ig,
      sg = {
        event: {
          status: { success: Am.Success, fail: Am.Fail, appointment: Am.Appointment },
          type: {
            payment: Im.Payment,
            installment: Im.Installment,
            error: Im.Error,
            cancel: Im.Cancel,
          },
        },
      };
    (e.CloudPayments = ag),
      (e.Widget = cg),
      (e.constant = sg),
      Object.defineProperty(e, '__esModule', { value: !0 });
  })((this.cp = this.cp || {}));
}
//# sourceMappingURL=cloudpayments.js.map
